// Alguns SVGs reutilizáveis
import React from 'react';

export const VdbIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    fill = "#FFF"
    xmlns = "http://www.w3.org/2000/svg"
    width = "160px"
    height = "52px"
    viewBox = "0 0 160 52" >
    <
    path d = "M152.249 13.166c.429.277.921.513 1.468.701.546.19 1.11.378 1.688.563.579.186 1.141.391 1.689.614a6.101 6.101 0 0 1 1.468.841c.432.337.779.752 1.044 1.246.261.493.394 1.106.394 1.84 0 .749-.133 1.456-.394 2.118a4.956 4.956 0 0 1-1.145 1.726c-.5.49-1.112.875-1.834 1.158-.723.282-1.552.423-2.48.423-1.207 0-2.246-.208-3.116-.626a7.362 7.362 0 0 1-2.288-1.713l.363-.558a.46.46 0 0 1 .363-.189c.076 0 .176.05.297.151.122.102.267.227.439.374.173.148.381.308.622.479.241.174.522.335.843.483.317.146.684.271 1.097.372.414.101.886.151 1.41.151.725 0 1.372-.106 1.942-.322a4.254 4.254 0 0 0 1.443-.878c.394-.371.693-.812.899-1.323a4.286 4.286 0 0 0 .311-1.637c0-.632-.13-1.152-.395-1.562a3.356 3.356 0 0 0-1.043-1.024 6.855 6.855 0 0 0-1.467-.689 67.566 67.566 0 0 0-1.69-.544 20.835 20.835 0 0 1-1.687-.593 5.814 5.814 0 0 1-1.468-.842 3.859 3.859 0 0 1-1.043-1.278c-.262-.509-.394-1.148-.394-1.915a4.415 4.415 0 0 1 1.37-3.206c.449-.425 1.005-.767 1.663-1.024.66-.257 1.414-.386 2.26-.386.948 0 1.8.148 2.554.443a6.142 6.142 0 0 1 2.064 1.353l-.311.581c-.077.144-.189.216-.335.216-.115 0-.259-.078-.435-.234a5.46 5.46 0 0 0-.72-.518 5.782 5.782 0 0 0-1.134-.526c-.453-.16-1.012-.24-1.678-.24-.667 0-1.252.093-1.757.278a3.672 3.672 0 0 0-1.27.759 3.22 3.22 0 0 0-.778 1.113 3.375 3.375 0 0 0-.266 1.327c0 .608.131 1.109.395 1.506.263.395.609.733 1.042 1.011zm.501 18.05c1.08 0 2.064.18 2.956.54a6.629 6.629 0 0 1 2.289 1.52 6.727 6.727 0 0 1 1.472 2.326c.353.899.525 1.887.525 2.962 0 1.077-.172 2.064-.525 2.964a6.68 6.68 0 0 1-1.472 2.319 6.58 6.58 0 0 1-2.289 1.511c-.892.355-1.876.534-2.956.534s-2.062-.179-2.951-.534a6.569 6.569 0 0 1-2.282-1.511 6.732 6.732 0 0 1-1.476-2.319c-.349-.9-.523-1.887-.523-2.964 0-1.075.174-2.063.523-2.962a6.781 6.781 0 0 1 1.476-2.326 6.618 6.618 0 0 1 2.282-1.52c.889-.36 1.871-.54 2.951-.54zm-4.835 4.972c-.246.701-.37 1.494-.37 2.376 0 .882.124 1.672.37 2.371a4.946 4.946 0 0 0 1.051 1.775 4.519 4.519 0 0 0 1.642 1.112c.643.258 1.357.386 2.142.386.793 0 1.508-.128 2.15-.386a4.45 4.45 0 0 0 1.639-1.112 4.919 4.919 0 0 0 1.044-1.775c.25-.699.371-1.489.371-2.371 0-.882-.121-1.675-.371-2.376a4.915 4.915 0 0 0-1.044-1.78 4.512 4.512 0 0 0-1.639-1.118c-.642-.261-1.357-.388-2.15-.388-.785 0-1.499.127-2.142.388a4.583 4.583 0 0 0-1.642 1.118 4.942 4.942 0 0 0-1.051 1.78zm-1.795-12.09a.602.602 0 0 1-.179-.246l-2.158-5.196h-8.98l-2.145 5.196a.54.54 0 0 1-.183.241.486.486 0 0 1-.308.1h-1.009l7.482-17.894h1.319l7.481 17.894h-1.022a.459.459 0 0 1-.298-.095zm-6.459-15.446a7.11 7.11 0 0 1-.183-.487c-.06-.182-.118-.373-.179-.576-.06.203-.122.394-.182.576a9.95 9.95 0 0 1-.179.5l-3.735 9.028h8.193l-3.735-9.041zm-12.264 13.139a7.74 7.74 0 0 1-2.753 1.783c-1.068.412-2.252.619-3.553.619h-6.667V6.3h6.667c1.301 0 2.485.206 3.553.618a7.756 7.756 0 0 1 2.753 1.784c.766.775 1.362 1.716 1.784 2.821.421 1.103.633 2.343.633 3.717 0 1.383-.212 2.626-.633 3.731-.422 1.103-1.018 2.044-1.784 2.82zm.516-9.889c-.351-.979-.849-1.804-1.491-2.48a6.392 6.392 0 0 0-2.319-1.542c-.907-.354-1.91-.531-3.012-.531h-5.336v15.795h5.336c1.102 0 2.105-.177 3.012-.531a6.394 6.394 0 0 0 2.319-1.543c.642-.674 1.14-1.5 1.491-2.478.355-.979.53-2.096.53-3.352 0-1.248-.175-2.36-.53-3.338zm-14.471 33.84a.665.665 0 0 1-.429-.13.82.82 0 0 1-.248-.331l-1.371-3.469h-6.588l-1.372 3.469a.802.802 0 0 1-.246.321.666.666 0 0 1-.431.14h-1.536l5.871-14.367h2.017l5.869 14.367h-1.536zm-4.907-11.178c-.15-.36-.299-.812-.44-1.354-.075.275-.149.526-.221.758a9.259 9.259 0 0 1-.208.606l-2.308 5.835h5.483l-2.306-5.845zm-1.36-28.265h1.331v17.895h-1.331V6.299zM97.108 24.194h-1.317V7.399H89.33V6.3h14.201v1.099h-6.423v16.795zm-10.891-1.379c-.499.49-1.112.875-1.835 1.158-.725.282-1.552.423-2.482.423-1.205 0-2.246-.208-3.113-.626a7.328 7.328 0 0 1-2.288-1.713l.362-.558a.46.46 0 0 1 .363-.189c.077 0 .175.05.297.151l.44.374c.171.148.378.308.62.479.241.174.522.335.842.483.318.146.685.271 1.099.372a5.98 5.98 0 0 0 1.411.151c.724 0 1.371-.106 1.94-.322a4.249 4.249 0 0 0 1.444-.878 3.74 3.74 0 0 0 .9-1.323c.206-.509.31-1.055.31-1.637 0-.632-.132-1.152-.395-1.562a3.378 3.378 0 0 0-1.043-1.024 6.782 6.782 0 0 0-1.469-.689 63.532 63.532 0 0 0-1.687-.544 21.155 21.155 0 0 1-1.689-.593 5.855 5.855 0 0 1-1.469-.842 3.865 3.865 0 0 1-1.041-1.278c-.263-.509-.396-1.148-.396-1.915 0-.599.118-1.177.351-1.732a4.3 4.3 0 0 1 1.022-1.474c.448-.425 1.003-.767 1.664-1.024.658-.257 1.411-.386 2.257-.386.948 0 1.8.148 2.555.443a6.138 6.138 0 0 1 2.063 1.353l-.311.581c-.077.144-.189.216-.334.216-.114 0-.257-.078-.435-.234a5.744 5.744 0 0 0-1.854-1.044c-.454-.16-1.013-.24-1.68-.24-.665 0-1.25.093-1.756.278a3.68 3.68 0 0 0-1.27.759c-.341.321-.6.691-.779 1.113a3.392 3.392 0 0 0-.266 1.327c0 .608.132 1.109.395 1.506.264.395.61.733 1.043 1.011.432.277.921.513 1.467.701.549.19 1.112.378 1.691.563.578.186 1.14.391 1.688.614a6.108 6.108 0 0 1 1.469.841c.43.337.778.752 1.042 1.246.262.493.393 1.106.393 1.84 0 .749-.131 1.456-.393 2.118a4.937 4.937 0 0 1-1.143 1.726zm-2.755 8.822c.651.173 1.189.42 1.61.742.419.32.73.712.931 1.177.201.463.303.988.303 1.57 0 .354-.058.695-.171 1.022a2.947 2.947 0 0 1-.51.911 3.624 3.624 0 0 1-.862.752 4.817 4.817 0 0 1-1.213.542c1.071.208 1.88.586 2.428 1.134.545.547.819 1.269.819 2.165 0 .608-.116 1.163-.343 1.664a3.58 3.58 0 0 1-1.005 1.294c-.439.36-.98.64-1.619.837-.637.197-1.366.295-2.187.295H76.45V31.375h4.683c.9 0 1.676.087 2.329.262zm-5.025 12.56h3.175c.569 0 1.054-.063 1.462-.19.405-.125.74-.305 1.004-.533a2.12 2.12 0 0 0 .579-.824c.122-.318.184-.668.184-1.049 0-.742-.269-1.328-.805-1.757-.537-.432-1.348-.648-2.433-.648h-3.166v5.001zm0-6.386h2.622c.56 0 1.045-.06 1.456-.179.409-.121.749-.287 1.018-.501.272-.215.471-.473.6-.778.13-.305.195-.636.195-.998 0-.841-.259-1.461-.778-1.855-.52-.393-1.327-.592-2.417-.592h-2.696v4.903zM62.815 6.3h10.958v1.074h-9.627v7.233h8.01v1.051h-8.01v7.46h9.627v1.076H62.815V6.3zm6.822 26.66H62.59v4.772h5.706v1.524H62.59v4.901h7.047v1.585h-9.045V31.375h9.045v1.585zm-18.451-8.766L43.639 6.3h1.047c.119 0 .22.031.297.095a.612.612 0 0 1 .181.247l6.229 14.845c.162.388.296.801.4 1.239.095-.455.219-.867.374-1.239l6.214-14.845a.73.73 0 0 1 .19-.242.46.46 0 0 1 .304-.1h1.032l-7.544 17.894h-1.177zM15.738 43.209a.643.643 0 0 1-.424-.159c-3.884-3.408-5.762-5.381-5.921-7.369l-.001-.048v-.64l.002-.049c.188-2.284 1.761-3.468 3.142-3.599.203-.02.396-.03.58-.03 1.018 0 1.973.577 2.609 1.502.58-.857 1.498-1.502 2.638-1.502.181 0 .372.01.577.03 1.384.131 2.957 1.315 3.143 3.599l.003.049v.64l-.002.048c-.151 1.89-1.983 4.167-5.941 7.385a.646.646 0 0 1-.405.143zm5.08-8.19c-.137-1.559-1.13-2.358-2-2.44a4.966 4.966 0 0 0-.455-.024c-1.032 0-1.803.995-2.004 1.93a.632.632 0 0 1-.607.492.627.627 0 0 1-.627-.467c-.246-.941-.98-1.955-2.009-1.955-.144 0-.295.009-.457.024-.87.082-1.863.882-1.999 2.44v.588c.149 1.622 2.36 3.749 5.093 6.16 3.278-2.716 4.935-4.734 5.065-6.16v-.588zm-5.089-21.994L22.045 6.5l.994.923-7.31 7.539-7.31-7.539.994-.922 6.316 6.524zm-.096 10.034h-.014c-7.65 0-13.8 6.092-13.8 13.58 0 7.489 6.15 13.582 13.8 13.582 7.652 0 13.878-6.093 13.878-13.582 0-5.081-2.869-9.517-7.102-11.846l1.331-1.303c4.545 2.695 7.589 7.58 7.589 13.149C31.315 45.11 24.274 52 15.619 52 6.965 52 0 45.11 0 36.639c0-8.297 6.68-15.074 15.09-15.348L28.839 6.78l-4.594-5H7.017L2.573 6.795l9.146 9.401-1.252 1.293L0 6.795 6.264-.001h18.791l6.263 6.812L15.899 23.07l-.266-.011zm37.972 8.834a6.545 6.545 0 0 1 2.285 1.463 6.597 6.597 0 0 1 1.476 2.269c.347.884.522 1.864.522 2.939 0 1.077-.175 2.055-.522 2.938a6.537 6.537 0 0 1-1.476 2.266 6.605 6.605 0 0 1-2.285 1.458c-.888.343-1.873.516-2.951.516h-5.49V31.374h5.49c1.078 0 2.063.175 2.951.519zm-6.443 12.274h3.492c.787 0 1.499-.126 2.14-.379a4.55 4.55 0 0 0 1.643-1.099 4.935 4.935 0 0 0 1.043-1.759c.248-.695.37-1.484.37-2.366 0-.882-.122-1.671-.37-2.365a4.984 4.984 0 0 0-1.043-1.766c-.454-.482-1-.847-1.643-1.102-.641-.255-1.353-.381-2.14-.381h-3.492v11.217zm49.306-12.515c.676.183 1.234.45 1.675.796.438.348.767.767.977 1.257.213.493.318 1.042.318 1.65 0 .509-.08.984-.247 1.425a3.66 3.66 0 0 1-.711 1.187 4.198 4.198 0 0 1-1.136.899 5.758 5.758 0 0 1-1.521.56c.246.141.464.345.655.612l4.28 5.704h-1.76c-.361 0-.629-.136-.798-.41l-3.812-5.134a1.093 1.093 0 0 0-.377-.346c-.138-.07-.343-.107-.617-.107h-1.506v5.997h-1.977V31.375h4.15c.927 0 1.73.092 2.407.277zm-4.58 6.682h2.08c.581 0 1.09-.069 1.532-.206a3.176 3.176 0 0 0 1.106-.582c.297-.251.519-.549.671-.897a2.88 2.88 0 0 0 .226-1.152c0-.857-.288-1.502-.867-1.936-.576-.434-1.435-.653-2.575-.653h-2.173v5.426zm26.365-6.893c.086.043.182.133.292.265l8.503 10.829a8.533 8.533 0 0 1-.051-.985V31.374h1.74v14.368h-1.003a.876.876 0 0 1-.396-.08.971.971 0 0 1-.311-.27l-8.493-10.818c.013.167.025.33.032.492.004.159.009.306.009.441v10.235h-1.741V31.374h1.024c.179 0 .31.023.395.067zm15.255 1.82a6.875 6.875 0 0 1 2.333-1.509c.905-.359 1.903-.536 2.997-.536 1.078 0 2.008.163 2.792.491.783.326 1.478.77 2.085 1.333l-.645.893-.165.165a.47.47 0 0 1-.266.065.524.524 0 0 1-.282-.096c-.101-.062-.217-.142-.352-.235a8.667 8.667 0 0 0-.484-.302 4.488 4.488 0 0 0-.654-.301 5.519 5.519 0 0 0-.882-.234 6.324 6.324 0 0 0-1.157-.093c-.785 0-1.505.13-2.158.393a4.86 4.86 0 0 0-1.685 1.128 5.173 5.173 0 0 0-1.102 1.785c-.261.701-.392 1.487-.392 2.356 0 .896.131 1.695.392 2.396.265.702.622 1.295 1.076 1.781.456.484.994.853 1.616 1.106a5.23 5.23 0 0 0 2.008.382c.436 0 .828-.026 1.179-.075.347-.052.67-.13.967-.236.296-.108.573-.242.83-.405.256-.164.512-.361.771-.588.118-.1.231-.15.34-.15.109 0 .208.043.297.129l.781.833a6.332 6.332 0 0 1-2.189 1.595c-.859.38-1.892.571-3.1.571-1.058 0-2.018-.178-2.878-.538a6.27 6.27 0 0 1-2.202-1.503 6.744 6.744 0 0 1-1.415-2.32c-.334-.903-.501-1.896-.501-2.978 0-1.083.178-2.075.538-2.978a6.821 6.821 0 0 1 1.507-2.325z" / >
    <
    /svg>
  );
};

export const FacebookIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    fill = "#e7f1f4"
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path d = "M17.879 0H2.121C.951 0 0 .951 0 2.121v15.758C0 19.049.951 20 2.121 20H10v-7.556H7.556V9.111H10V7.812c0-2.239 1.682-4.256 3.75-4.256h2.694v3.333H13.75c-.295 0-.639.358-.639.894v1.328h3.333v3.333h-3.333V20h4.768c1.17 0 2.121-.951 2.121-2.121V2.121C20 .951 19.049 0 17.879 0z" / >
    <
    /svg>
  );
};

export const InstagramIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    fill = "#e7f1f4"
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path d = "M2.121 0C.951 0 0 .951 0 2.121v15.758C0 19.049.951 20 2.121 20h15.758c1.17 0 2.121-.951 2.121-2.121V2.121C20 .951 19.049 0 17.879 0H2.121zm0 .606h15.758c.844 0 1.515.671 1.515 1.515v7.576h-4.858A4.552 4.552 0 0 0 10 5.455a4.552 4.552 0 0 0-4.536 4.242H.606V2.121c0-.844.671-1.515 1.515-1.515zm13.94 1.818a1.212 1.212 0 1 0 0 2.424 1.212 1.212 0 0 0 0-2.424zM10 6.061A3.934 3.934 0 0 1 13.939 10 3.934 3.934 0 0 1 10 13.939 3.934 3.934 0 0 1 6.061 10 3.934 3.934 0 0 1 10 6.061zM.606 10.303h4.858A4.552 4.552 0 0 0 10 14.545a4.552 4.552 0 0 0 4.536-4.242h4.858v7.576c0 .844-.671 1.515-1.515 1.515H2.121a1.506 1.506 0 0 1-1.515-1.515v-7.576z" / >
    <
    /svg>
  );
};

export const LinkedinIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    fill = "#E7F1F4"
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path d = "M17.879 0H2.121C.951 0 0 .951 0 2.121v15.758C0 19.049.951 20 2.121 20h15.758c1.17 0 2.121-.951 2.121-2.121V2.121C20 .951 19.049 0 17.879 0zM6.15 17.15h-3v-9h3v9zm-1.5-10.7c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8zm12.5 10.7h-3v-5.3c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v5.3h-3v-9h3v1.2c.5-.8 1.6-1.4 2.5-1.4 1.9 0 3.5 1.6 3.5 3.5v5.7z" / >
    <
    /svg>
  );
};

export const GooglePlusIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    fill = "#E7F1F4"
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path d = "M17.879 0H2.121C.951 0 0 .951 0 2.121v15.758C0 19.049.951 20 2.121 20h15.758c1.17 0 2.121-.951 2.121-2.121V2.121C20 .951 19.049 0 17.879 0zm-4.767 10.967c-.448 2.206-2.495 3.867-4.834 3.867a4.834 4.834 0 1 1 3.383-8.287l-1.092 1.187a3.223 3.223 0 1 0 .784 3.233H8.6V9.463h4.512v1.504zm3.444-.716h-.923v.923h-.791v-.923h-.923V9.46h.923v-.923h.791v.923h.923v.791z" / >
    <
    /svg>
  );
};

export const CirclePlusIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = "28.006" >
    <
    path fill = "#53adb3"
    fillRule = "evenodd"
    d = "M18.031 18.004c-1.943 1.927-4.319 2.912-7.063 2.93-2.768-.018-5.145-1.003-7.071-2.93a10.66 10.66 0 0 1-1.576-2 9.287 9.287 0 0 1-1.284-3.815 9.878 9.878 0 0 1-.069-1.251c0-2.762.986-5.14 2.93-7.069C5.825 1.928 8.203.942 10.964.942c2.745 0 5.122.985 7.066 2.928 1.944 1.929 2.93 4.307 2.93 7.068 0 2.745-.986 5.123-2.929 7.066zm-.822-13.308l-.002-.001c-1.741-1.741-3.784-2.588-6.243-2.588-2.474 0-4.515.846-6.242 2.586-1.743 1.73-2.589 3.771-2.589 6.245 0 .424.02.788.061 1.114A8.035 8.035 0 0 0 3.317 15.4a9.583 9.583 0 0 0 1.403 1.781c1.727 1.726 3.77 2.572 6.247 2.588 2.456-.016 4.5-.863 6.242-2.59 1.739-1.74 2.585-3.782 2.585-6.241 0-2.474-.846-4.515-2.585-6.242zm-1.226 7.081h-4.34v4.308a.583.583 0 1 1-1.165 0v-4.308H6.201a.582.582 0 1 1 0-1.165h4.277V6.303a.582.582 0 1 1 1.165 0v4.309h4.34a.583.583 0 1 1 0 1.165z" /
    >
    <
    /svg>
  );
};

export const CircleMinusIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = "28.006" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M18.031 18.005c-1.943 1.926-4.319 2.912-7.063 2.929-2.768-.017-5.145-1.003-7.071-2.929a10.722 10.722 0 0 1-1.577-2.001 9.301 9.301 0 0 1-1.284-3.815 10.245 10.245 0 0 1-.068-1.251c0-2.762.986-5.141 2.931-7.069C5.823 1.928 8.201.942 10.964.942c2.746 0 5.123.985 7.067 2.929 1.943 1.926 2.929 4.305 2.929 7.067 0 2.746-.986 5.123-2.929 7.067zm-.822-13.309c-1.743-1.743-3.785-2.589-6.245-2.589-2.475 0-4.516.846-6.241 2.586-1.744 1.729-2.59 3.77-2.59 6.245 0 .426.019.791.06 1.115A8.05 8.05 0 0 0 3.316 15.4c.39.639.863 1.239 1.405 1.78 1.726 1.727 3.769 2.573 6.246 2.589 2.456-.016 4.5-.863 6.242-2.59 1.739-1.739 2.585-3.781 2.585-6.241 0-2.475-.846-4.516-2.585-6.242zm-1.226 7.081H6.201a.583.583 0 1 1 0-1.165h9.782a.583.583 0 1 1 0 1.165z" /
    >
    <
    /svg>
  );
};

export const ChainIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path fill = "#53adb3"
    fillRule = "evenodd"
    d = "M18.982 8.227l-3.297 3.469a.798.798 0 0 1-1.206.037.874.874 0 0 1 0-1.255l3.297-3.469a.55.55 0 0 0 0-.775l-4.041-4.281a.501.501 0 0 0-.745 0L9.693 5.422a.794.794 0 0 1-1.205 0 .871.871 0 0 1 0-1.254l3.297-3.47a2.215 2.215 0 0 1 1.595-.701c.603 0 1.17.259 1.596.701l4.006 4.245c.851.922.851 2.398 0 3.284zm-6.311-.886a.873.873 0 0 1 0 1.255l-3.899 4.097c-.178.184-.39.295-.639.295a.815.815 0 0 1-.602-.258.873.873 0 0 1 0-1.255l3.935-4.134a.794.794 0 0 1 1.205 0zm-.921 7.234a.874.874 0 0 1 0 1.255l-3.298 3.469c-.39.479-.992.701-1.595.701a2.21 2.21 0 0 1-1.595-.701l-4.006-4.244c-.851-.923-.851-2.399 0-3.285l3.297-3.469a.794.794 0 0 1 1.205 0 .873.873 0 0 1 0 1.255l-3.297 3.469a.55.55 0 0 0 0 .775l4.042 4.244a.5.5 0 0 0 .744 0l3.297-3.469a.795.795 0 0 1 1.206 0z" /
    >
    <
    /svg>
  );
};

export const SearchIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "28.006" >
    <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M12.842 14.333c-1.758 0-3.394-.612-4.621-1.674l-.646.645a.594.594 0 0 1-.859 0 .618.618 0 0 1-.163-.45c0-.163.041-.327.163-.449l.646-.645C6.34 10.494 5.685 8.901 5.685 7.145c0-3.92 3.231-7.147 7.157-7.147s7.157 3.227 7.157 7.147c0 3.921-3.231 7.147-7.157 7.188zm0-13.11c-3.272 0-5.93 2.655-5.93 5.922a5.93 5.93 0 0 0 5.93 5.922 5.93 5.93 0 0 0 5.93-5.922c0-3.267-2.658-5.922-5.93-5.922zM6.41 13.61a.593.593 0 0 1 0 .858l-5.387 5.379c-.245.204-.654.204-.859.041a.618.618 0 0 1-.163-.45c0-.163.041-.327.163-.449l5.387-5.379a.594.594 0 0 1 .859 0z" /
    >
    <
    /svg>
  );
};

export const SeparadorIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "2.646cm"
    height = "21.317" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M64.335 6.473c.068-.688.678-1.472 1.858-1.565h.38c1.027.079 2.045 1.015 3.806 2.951a.314.314 0 0 1 .008.412c-1.661 1.972-2.837 2.884-3.814 2.96h-.38c-1.18-.094-1.79-.877-1.858-1.566a2.701 2.701 0 0 1-.016-.288c0-.568.333-1.025.776-1.314-.478-.317-.776-.794-.776-1.3 0-.092.005-.189.016-.29zm1.634 1.291a.311.311 0 0 1 .241.312.316.316 0 0 1-.254.302c-.483.1-.996.485-.996.999 0 .071.003.145.011.226.044.434.456.929 1.261.997h.303c.737-.064 1.779-.89 3.181-2.524-1.246-1.361-2.343-2.462-3.181-2.538h-.304c-.804.068-1.216.564-1.26.997a2.298 2.298 0 0 0-.011.228c0 .512.524.878 1.009 1.001zM51.982 4.422l3.893 3.642-3.893 3.643-.476-.497 3.369-3.146-3.369-3.148.476-.494zM67.068 15.83a7.96 7.96 0 0 1-6.789-3.781l.672-.664a7.034 7.034 0 0 0 6.117 3.538c3.867 0 7.014-3.101 7.014-6.913 0-3.812-3.147-6.914-7.014-6.914-3.867 0-7.012 3.102-7.012 6.914l.001.007.006.132-8.396 7.847-3.517-3.128V3.459L51.659 0l5.521 5.444-.668.623-4.853-4.786-2.59 2.554v8.63l2.581 2.296 7.494-7.014c.14-4.191 3.64-7.557 7.924-7.557C71.442.19 75 3.698 75 8.01s-3.558 7.82-7.932 7.82zM29.58 7.274h15.841v1.447H29.58V7.274zM10.666 9.665c-.068.689-.678 1.472-1.858 1.566h-.38c-.977-.076-2.153-.988-3.815-2.96a.32.32 0 0 1-.073-.202.31.31 0 0 1 .082-.21C6.382 5.923 7.4 4.987 8.428 4.908h.38c1.18.093 1.79.877 1.858 1.565.011.101.016.198.016.29 0 .506-.298.983-.776 1.3.442.289.776.746.776 1.314 0 .09-.005.185-.016.288zM9.043 8.378a.318.318 0 0 1-.253-.302.311.311 0 0 1 .241-.312c.486-.123 1.01-.489 1.01-1.001a2.04 2.04 0 0 0-.012-.228c-.043-.433-.456-.929-1.26-.997h-.304c-.837.076-1.934 1.177-3.181 2.538 1.401 1.634 2.444 2.46 3.181 2.524h.304c.804-.068 1.217-.563 1.26-.997.009-.08.012-.155.012-.226 0-.514-.514-.899-.998-.999zm13.974 3.329l-3.892-3.643 3.892-3.642.477.494-3.369 3.148 3.369 3.146-.477.497zm-8.079-3.558l.005-.132.001-.007c0-3.812-3.146-6.914-7.012-6.914C4.066 1.096.918 4.198.918 8.01s3.148 6.913 7.014 6.913a7.034 7.034 0 0 0 6.117-3.538l.673.664a7.962 7.962 0 0 1-6.79 3.781C3.558 15.83 0 12.322 0 8.01S3.558.19 7.932.19c4.284 0 7.784 3.366 7.925 7.557l7.493 7.014 2.582-2.296v-8.63l-2.59-2.554-4.854 4.786-.667-.623L23.342 0l3.509 3.459v9.409l-3.518 3.128-8.395-7.847z" /
    >
    <
    /svg>
  );
};

export const MissionIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "103px"
    height = "104px" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M51.5 0C79.943 0 103 23.127 103 51.656s-23.057 51.656-51.5 51.656S0 80.185 0 51.656 23.057 0 51.5 0z" /
    >
    <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M66.849 73.949H37.405c-2.846 0-4.413-1.539-4.413-4.334V33.253c0-1.429.387-2.528 1.147-3.266.753-.729 1.839-1.098 3.275-1.069h23.194c.181 0 .355.073.48.201l9.987 10.209c.12.122.187.284.187.454v29.833c0 2.795-1.567 4.334-4.413 4.334zm-5.978-43.161v5.675c-.016 1.04.22 1.805.702 2.286.491.49 1.291.738 2.376.738h5.433l-8.511-8.699zm9.057 10.01h-5.979c-1.456 0-2.575-.38-3.326-1.129-.742-.74-1.107-1.822-1.086-3.216v-6.224H37.405c-1.042-.025-1.84.217-2.329.691-.498.483-.751 1.267-.751 2.333v36.362c0 2.091.95 3.024 3.08 3.024h29.444c2.129 0 3.079-.933 3.079-3.024V40.798zM61.195 64.75h-17.66a.66.66 0 0 1-.667-.655c0-.362.298-.656.667-.656h17.66c.369 0 .667.294.667.656a.66.66 0 0 1-.667.655zm0-7.286h-17.66a.66.66 0 0 1-.667-.655c0-.362.298-.656.667-.656h17.66c.369 0 .667.294.667.656a.66.66 0 0 1-.667.655zm0-7.359h-17.66a.66.66 0 0 1-.667-.655c0-.362.298-.656.667-.656h17.66c.369 0 .667.294.667.656a.66.66 0 0 1-.667.655zm0-7.107h-17.66a.66.66 0 0 1-.667-.655.66.66 0 0 1 .667-.655h17.66a.66.66 0 0 1 .667.655.66.66 0 0 1-.667.655z" /
    >
    <
    /svg>
  );
};

export const VisionIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "103px"
    height = "104px" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M51.5.531c28.443 0 51.5 23.128 51.5 51.657 0 28.528-23.057 51.656-51.5 51.656S0 80.716 0 52.188C0 23.659 23.057.531 51.5.531z" /
    >
    <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M75.067 52.602c-7.408 9.157-15.153 13.897-23.022 14.088-.165.004-.331.006-.497.006-8.091 0-16.468-4.793-24.908-14.253a.668.668 0 0 1 .002-.891c8.381-9.281 16.703-13.983 24.745-13.983.186 0 .372.003.56.007 7.901.216 15.68 4.989 23.12 14.187a.667.667 0 0 1 0 .839zM51.911 38.906c-7.627-.204-15.716 4.196-23.883 13.096 8.204 9.051 16.23 13.54 23.985 13.358 7.344-.179 14.637-4.611 21.684-13.178-7.081-8.608-14.408-13.075-21.786-13.276zm-1.02 22.071c-2.449-.039-4.448-.882-6.133-2.575-1.679-1.683-2.529-3.763-2.529-6.183 0-2.418.85-4.499 2.529-6.184 1.701-1.708 3.703-2.538 6.123-2.538 2.409 0 4.481.854 6.157 2.538 1.662 1.669 2.525 3.746 2.567 6.173-.042 2.451-.905 4.527-2.567 6.194-1.661 1.669-3.73 2.536-6.147 2.575zm5.21-14.001c-1.439-1.446-3.147-2.149-5.22-2.149-2.05 0-3.747.703-5.186 2.149-1.44 1.446-2.141 3.161-2.141 5.243 0 2.082.701 3.798 2.141 5.242 1.43 1.438 3.129 2.152 5.196 2.186 2.069-.034 3.78-.749 5.21-2.186 1.43-1.435 2.143-3.153 2.178-5.253-.035-2.077-.748-3.795-2.178-5.232z" /
    >
    <
    /svg>
  );
};

export const ValuesIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "103px"
    height = "104px" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M51.531.719c28.46 0 51.532 23.218 51.532 51.859 0 28.641-23.072 51.859-51.532 51.859C23.071 104.437 0 81.219 0 52.578 0 23.937 23.071.719 51.531.719z" /
    >
    <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M73.151 56.492a3.4 3.4 0 0 0 1.122-.744c.631-.666.973-1.488 1.018-2.445a.461.461 0 0 0-.011-.161c-.024-.155-.024-.978-.034-2.043a3.435 3.435 0 0 0-.988-1.905c-.636-.631-1.642-.952-2.989-.952H58.021a7.003 7.003 0 0 0 1.156-3.147c.048-.467.078-2.394.072-5.005l-.957-6.396a3.36 3.36 0 0 0-.949-1.746c-.692-.683-1.472-.995-2.373-.95-.951-.038-1.813.288-2.438.952-.692.685-1.006 1.473-.951 2.297l-1.219 6.601c-1.886 5.634-4.723 9.487-8.416 11.518a1.905 1.905 0 0 0-.448-.686c-.405-.385-.976-.565-1.649-.545h-8.454c-.714-.035-1.301.161-1.709.552-.411.393-.62.964-.62 1.695v19.233c0 1.428.841 2.247 2.307 2.247h8.476c1.228 0 2.026-.628 2.222-1.704 1.47.839 3.191 1.373 5.195 1.56h20.458c1.022 0 1.88-.359 2.624-1.095l.271-.273c.509-.631.792-1.403.838-2.326 0-1.011-.363-1.861-1.108-2.597l-.101-.099a3.858 3.858 0 0 0 1.532-.899l.172-.205c.546-.623.847-1.402.893-2.374-.04-.896-.337-1.658-.859-2.244.497-.182.958-.482 1.39-.909.666-.75 1.004-1.59 1.004-2.495 0-.994-.36-1.856-1.071-2.562a5.352 5.352 0 0 0-.158-.148zM40.794 72.615c0 .681-.257.934-.945.934h-8.476c-.723 0-.98-.244-.98-.934V53.382c0-.249.038-.581.216-.751.173-.167.499-.193.764-.183l8.499-.001c.308-.01.568.048.704.178.18.172.218.506.218.757v19.233zm31.577-11.781c-.467.461-.992.676-1.597.677l-.438-.035a.653.653 0 0 0-.7.504.654.654 0 0 0 .399.76c.292.116.528.279.779.555.445.414.676.941.705 1.551-.031.62-.217 1.116-.579 1.529l-.124.156c-.476.441-1.009.655-1.63.655a.669.669 0 0 0-.254.05l-.048-.016c-.354-.117-.763.054-.88.397-.115.345.033.699.381.814.065.04.379.284 1.026.924.497.492.719 1.007.72 1.635-.032.619-.212 1.122-.499 1.485l-.221.218c-.498.492-1.018.711-1.687.711l-20.395.003c-2.045-.193-3.786-.796-5.208-1.767V53.768c4.227-2.124 7.429-6.319 9.524-12.595l1.242-6.689a.952.952 0 0 0 .009-.185c-.026-.563.151-1.002.59-1.437.377-.399.846-.574 1.484-.551.552-.025 1.01.146 1.435.567.311.307.501.658.581 1.041l.942 6.267c0 2.8-.036 4.441-.069 4.767a5.747 5.747 0 0 1-1.711 3.481.655.655 0 0 0 .47 1.121h14.651c.982 0 1.671.191 2.051.568.336.331.533.715.609 1.089 0 1.349.001 1.843.034 2.094-.043.616-.257 1.12-.643 1.528-.403.4-.922.602-1.587.604l-.51.036a.66.66 0 0 0-.617.655v.145c0 .316.226.587.541.645.475.088.864.296 1.223.649.466.463.683.982.683 1.634 0 .584-.221 1.116-.682 1.632z" /
    >
    <
    /svg>
  );
};

export const CartIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "54.652"
    height = "48" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M15.067 26.478c-2.358 0-4.313 1.954-4.313 4.311s1.955 4.312 4.313 4.312c2.358 0 4.313-1.955 4.313-4.312a4.306 4.306 0 0 0-4.313-4.311zm0 6.323c-1.093 0-2.013-.92-2.013-2.012s.92-2.012 2.013-2.012c1.092 0 2.012.92 2.012 2.012s-.92 2.012-2.012 2.012zm14.434-6.323c-2.357 0-4.313 1.954-4.313 4.311s1.956 4.312 4.313 4.312c2.358 0 4.313-1.955 4.313-4.312 0-2.414-1.897-4.311-4.313-4.311zm0 6.323a2.037 2.037 0 0 1-2.012-2.012c0-1.092.92-2.012 2.012-2.012 1.093 0 2.013.92 2.013 2.012a2 2 0 0 1-2.013 2.012zm5.636-13.509H12.536c.23.862.403 1.495.518 1.897.402 1.667 1.323 1.667 1.323 1.667h18.115c2.415 0 3.623 1.782 3.968 2.817.172.575-.115 1.265-.748 1.437-.115.057-.23.057-.345.057-.46 0-.92-.287-1.092-.747-.058-.115-.518-1.207-1.783-1.207H14.434s-2.703.173-3.623-3.392c-.575-2.299-4.198-15.865-5.176-19.429H1.15C.517 2.392 0 1.874 0 1.242 0 .61.517.092 1.15.092h5.348c.518 0 .978.345 1.093.862l4.255 16.096h22.429l3.91-12.129H11.156c-.632 0-1.15-.517-1.15-1.15 0-.632.518-1.149 1.15-1.149h28.639c.345 0 .69.172.92.459.231.288.288.69.173 1.035L36.23 18.545c-.173.402-.633.747-1.093.747z" /
    >
    <
    /svg>
  );
};



export const HeartIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "49.323"
    height = "42.671" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M34.139 2.926C32.249.996 29.926.017 27.235.017c-2.692 0-5.015.979-6.905 2.909-.513.524-.96 1.081-1.338 1.667a11.112 11.112 0 0 0-1.346-1.667C15.757.996 13.434.017 10.741.017c-2.691 0-5.014.979-6.903 2.909C1.93 4.874.962 7.247.962 9.978c0 1.547.309 2.977.908 4.23a9.747 9.747 0 0 0 1.457 2.297c.009.011.022.015.031.025.009.01.012.022.021.032 3.341 3.375 6.67 6.762 10.002 10.154l4.91 4.993c.057.058.126.089.191.129.046.029.086.071.135.092a.973.973 0 0 0 .743-.001c.05-.021.091-.064.137-.093.065-.04.134-.071.19-.129l.248-.253c4.87-4.973 9.738-9.947 14.687-14.948a10.92 10.92 0 0 0 1.484-2.296c.585-1.287.881-2.711.881-4.232 0-2.749-.959-5.122-2.848-7.052zm.185 10.409a8.802 8.802 0 0 1-1.144 1.791 3516.022 3516.022 0 0 0-14.193 14.442l-4.21-4.282c-3.32-3.38-6.637-6.755-9.965-10.117a7.733 7.733 0 0 1-1.156-1.827c-.475-.995-.716-2.127-.716-3.364 0-2.206.751-4.046 2.296-5.624 1.526-1.56 3.327-2.317 5.505-2.317 2.18 0 3.981.757 5.507 2.317a8.941 8.941 0 0 1 1.862 2.777c.161.374.552.607.925.604a.99.99 0 0 0 .901-.643c.378-.988.98-1.909 1.792-2.738 1.527-1.56 3.329-2.317 5.507-2.317 2.178 0 3.979.757 5.506 2.317 1.526 1.559 2.269 3.399 2.269 5.624 0 1.225-.235 2.363-.686 3.357z" /
    >
    <
    /svg>
  );
};

export const ListIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "39.987"
    height = "46.677" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M26.145 35.008H3.855c-2.445 0-3.846-1.374-3.846-3.77V3.773c0-1.217.343-2.165 1.019-2.819.67-.647 1.605-.974 2.841-.95h17.552c.275 0 .537.11.727.304l7.561 7.711c.182.184.282.43.282.686v22.533c0 2.396-1.401 3.77-3.846 3.77zM22.125 3.14v3.058c-.01.655.12 1.114.386 1.38.273.272.758.41 1.439.41h2.928L22.125 3.14zm5.847 6.827H23.95c-1.242 0-2.211-.336-2.877-1-.661-.657-.987-1.594-.968-2.784V1.984H3.855c-.69-.015-1.139.119-1.409.38-.277.268-.418.742-.418 1.409v27.465c0 1.305.495 1.79 1.827 1.79h22.29c1.332 0 1.827-.485 1.827-1.79V9.967zm-6.107 18.092H8.495a1 1 0 0 1-1.01-.99 1 1 0 0 1 1.01-.99h13.37a1 1 0 0 1 1.01.99 1 1 0 0 1-1.01.99zm0-5.503H8.495a1 1 0 0 1-1.01-.99 1 1 0 0 1 1.01-.99h13.37a1 1 0 0 1 1.01.99 1 1 0 0 1-1.01.99zm0-5.559H8.495a1 1 0 0 1-1.01-.99 1 1 0 0 1 1.01-.99h13.37a1 1 0 0 1 1.01.99 1 1 0 0 1-1.01.99zm0-5.368H8.495a1 1 0 0 1-1.01-.99 1 1 0 0 1 1.01-.99h13.37a1 1 0 0 1 1.01.99 1 1 0 0 1-1.01.99z" /
    >
    <
    /svg>
  );
};

export const CertificateIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "44"
    height = "43" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M 6.4375 0.109375 C 6.167969 0.195312 6.027344 0.308594 5.292969 1.027344 C 4.515625 1.792969 4.449219 1.839844 3.453125 2.371094 C 2.15625 3.0625 2.066406 3.191406 1.863281 4.578125 C 1.722656 5.535156 1.644531 5.789062 1.167969 6.769531 C 0.507812 8.128906 0.507812 8.203125 1.257812 9.800781 C 1.691406 10.722656 1.753906 10.921875 1.863281 11.738281 C 2.042969 13.050781 2.246094 13.347656 3.347656 13.929688 C 3.628906 14.078125 3.859375 14.21875 3.859375 14.238281 C 3.859375 14.261719 3.367188 15.347656 2.765625 16.65625 C 0.105469 22.429688 -0.00390625 22.675781 0.0664062 22.691406 C 0.0976562 22.699219 0.746094 22.554688 1.507812 22.367188 C 3.492188 21.878906 3.8125 21.816406 3.882812 21.910156 C 3.910156 21.949219 4.21875 22.539062 4.566406 23.222656 C 5.699219 25.433594 5.726562 25.476562 5.863281 25.148438 C 6.128906 24.519531 8.960938 18.417969 8.992188 18.417969 C 9.039062 18.417969 10.0625 20.542969 11.039062 22.65625 C 12.257812 25.304688 12.304688 25.398438 12.355469 25.382812 C 12.382812 25.371094 12.808594 24.566406 13.300781 23.589844 C 13.789062 22.613281 14.203125 21.804688 14.214844 21.792969 C 14.230469 21.78125 14.667969 21.878906 15.191406 22.015625 C 16.144531 22.265625 17.910156 22.699219 17.96875 22.703125 C 18.03125 22.703125 15.917969 17.96875 14.460938 14.84375 C 14.140625 14.15625 14.117188 14.246094 14.722656 13.925781 C 15.828125 13.34375 15.988281 13.09375 16.210938 11.601562 C 16.335938 10.773438 16.496094 10.292969 16.902344 9.53125 C 17.527344 8.371094 17.519531 8.042969 16.8125 6.609375 C 16.417969 5.800781 16.3125 5.480469 16.207031 4.707031 C 16.003906 3.214844 15.867188 3.023438 14.515625 2.328125 C 13.75 1.9375 13.632812 1.851562 12.746094 1.015625 C 11.628906 -0.0351562 11.421875 -0.105469 10.207031 0.144531 C 9.515625 0.289062 8.472656 0.289062 7.824219 0.148438 C 7.3125 0.03125 6.730469 0.0195312 6.4375 0.109375 M 10.121094 3.128906 C 13.234375 3.726562 15.042969 7.464844 13.625 10.371094 C 11.632812 14.453125 5.871094 14.246094 4.269531 10.035156 C 2.8125 6.199219 6.074219 2.351562 10.121094 3.128906 M 18.230469 5.847656 C 18.777344 6.800781 18.910156 7.242188 18.9375 8.195312 L 18.957031 8.933594 L 30.84375 8.933594 L 30.84375 21.222656 L 32.484375 19.554688 L 34.121094 17.890625 L 34.121094 5.605469 L 18.09375 5.605469 L 18.230469 5.847656 M 18.105469 14.957031 L 18.117188 16.617188 L 27.492188 16.640625 L 27.464844 15.019531 C 27.453125 14.125 27.429688 13.386719 27.417969 13.371094 C 27.402344 13.359375 25.300781 13.335938 22.742188 13.320312 L 18.09375 13.296875 L 18.105469 14.957031 M 40.460938 14.910156 C 40.148438 14.972656 39.90625 15.148438 39.347656 15.714844 L 38.824219 16.246094 L 39.335938 16.746094 C 39.617188 17.023438 40.480469 17.871094 41.253906 18.636719 L 42.65625 20.027344 L 43.0625 19.621094 C 44.273438 18.40625 44.289062 18.15625 43.230469 16.972656 C 41.667969 15.21875 41.082031 14.78125 40.460938 14.910156 M 32.339844 22.894531 C 29.257812 26.0625 26.265625 29.140625 25.691406 29.734375 L 24.644531 30.820312 L 24.734375 30.945312 C 24.78125 31.011719 25.617188 31.875 26.589844 32.859375 L 28.359375 34.652344 L 41.765625 20.957031 L 39.929688 19.089844 C 38.921875 18.066406 38.0625 17.207031 38.019531 17.183594 C 37.957031 17.148438 36.953125 18.15625 32.339844 22.894531 M 18.757812 20.640625 C 18.773438 20.6875 19.074219 21.414062 19.417969 22.257812 L 20.046875 23.796875 L 27.476562 23.796875 L 27.476562 20.558594 L 23.101562 20.558594 C 18.914062 20.558594 18.726562 20.5625 18.757812 20.640625 M 8.875 22.464844 C 8.816406 22.582031 8.410156 23.460938 7.976562 24.417969 L 7.183594 26.160156 L 7.183594 42.988281 L 34.121094 42.988281 L 34.121094 32.023438 L 33.683594 32.484375 C 33.441406 32.734375 32.707031 33.515625 32.046875 34.222656 L 30.84375 35.503906 L 30.84375 39.660156 L 10.460938 39.660156 L 10.460938 25.265625 L 9.839844 23.925781 C 9.039062 22.207031 9.058594 22.246094 9.015625 22.246094 C 8.996094 22.246094 8.933594 22.34375 8.875 22.464844 M 13.828125 28.832031 L 13.828125 30.496094 L 23.058594 30.496094 L 26.371094 27.238281 L 23.566406 27.210938 C 22.027344 27.195312 19.203125 27.179688 17.296875 27.175781 L 13.828125 27.167969 L 13.828125 28.832031 M 23.617188 31.824219 C 23.617188 31.835938 23.484375 32.402344 23.324219 33.074219 L 23.035156 34.304688 L 24.964844 36.265625 L 26.109375 35.96875 C 26.742188 35.808594 27.28125 35.660156 27.3125 35.640625 C 27.347656 35.617188 26.734375 34.964844 25.492188 33.703125 C 24.460938 32.652344 23.617188 31.808594 23.617188 31.824219 M 22.875 35.023438 C 22.804688 35.21875 22.496094 36.609375 22.496094 36.734375 C 22.492188 36.871094 22.5 36.878906 22.617188 36.851562 C 23.171875 36.722656 24.117188 36.464844 24.246094 36.414062 L 24.402344 36.347656 L 23.90625 35.832031 C 23.210938 35.105469 22.925781 34.878906 22.875 35.023438 " /
    >
    <
    /svg>
  );
};



export const SearchIcon2 = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "42"
    height = "42" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M 12.886719 2.515625 C 0.699219 5.710938 -1.878906 22.253906 8.734375 29.1875 C 12.925781 31.925781 18.625 32.261719 23.253906 30.042969 L 24.980469 29.214844 L 29.972656 34.34375 C 32.71875 37.164062 35.226562 39.582031 35.550781 39.714844 C 37.734375 40.621094 39.898438 39.195312 39.898438 36.847656 C 39.898438 35.433594 39.949219 35.492188 34.269531 29.78125 L 29.324219 24.804688 L 30.089844 23.164062 C 35.4375 11.730469 25.097656 -0.683594 12.886719 2.515625 M 19.800781 6.933594 C 24.929688 8.515625 28.101562 14.085938 26.777344 19.171875 C 23.695312 30.996094 6.613281 28.976562 6.613281 16.785156 L 6.613281 14.144531 L 7.503906 12.347656 C 9.800781 7.710938 14.96875 5.4375 19.800781 6.933594" /
    >
    <
    /svg>
  );
};

export const ShieldIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "42.671"
    height = "48" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M19.014 36.796l-2.84 1.187-2.556-1.112A20.988 20.988 0 0 1 .973 17.607V8.386L16.254-.008l15.68 8.383v9.037a20.893 20.893 0 0 1-12.92 19.384zM29.91 9.586L16.267 2.293 2.998 9.582v8.025a18.968 18.968 0 0 0 11.428 17.41l1.764.767 2.046-.854A18.88 18.88 0 0 0 29.91 17.416v-7.83zM16.05 24.344a1.556 1.556 0 0 1-2.188.153l-3.933-3.401a1.552 1.552 0 0 1 2.033-2.345l2.763 2.388 6.066-6.944a1.554 1.554 0 0 1 2.192-.149c.646.563.713 1.543.15 2.189l-7.083 8.109z" /
    >
    <
    /svg>
  );
};

export const ThumbsUpIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "48"
    height = "46.677" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M35.996 18.282c.005-.096.011-.11-.013-.203-.013-.131-.013-.716-.013-1.393a.97.97 0 0 0-.015-.171 3.096 3.096 0 0 0-.887-1.697c-.579-.572-1.46-.862-2.618-.862h-9.166a5.888 5.888 0 0 0 .517-1.825c.037-.371.06-1.805.06-3.742 0-.049-.004-.097-.01-.145l-.728-4.836a3.003 3.003 0 0 0-.856-1.568c-.621-.609-1.358-.892-2.127-.858-.891-.042-1.658.264-2.224.86-.601.592-.895 1.302-.877 2.091l-.907 4.862c-1.312 3.862-3.221 6.574-5.682 8.092a1.89 1.89 0 0 0-.179-.205c-.28-.267-.788-.571-1.597-.549h-6.38c-.678-.021-1.248.163-1.659.555-.413.392-.622.941-.622 1.63v14.471c0 1.349.861 2.186 2.248 2.186h6.413c.918 0 1.607-.404 1.958-1.075 1.059.506 2.264.839 3.655.966h15.481c.899 0 1.688-.326 2.339-.968l.167-.163a.758.758 0 0 0 .076-.084c.453-.557.703-1.233.745-2.058 0-.685-.203-1.302-.596-1.844.224-.128.44-.273.638-.455.03-.028.06-.059.087-.09l.122-.147c.489-.554.758-1.24.798-2.131a3.3 3.3 0 0 0-.399-1.477 3.32 3.32 0 0 0 .676-.548c.587-.658.885-1.399.885-2.204a3.07 3.07 0 0 0-.634-1.912 3.32 3.32 0 0 0 .418-.349c.561-.589.866-1.313.906-2.154zM8.887 32.789c0 .112-.014.172-.01.187a.727.727 0 0 1-.203.022H2.261c-.133 0-.207-.018-.217-.013a.643.643 0 0 1-.022-.196V18.318c0-.11.012-.175.008-.196a.948.948 0 0 1 .231-.013H8.71l.045-.001c.056-.001.092.002.111.001a.829.829 0 0 1 .021.209v14.471zm24.759-13.727c-.21.207-.475.308-.881.31l-.386.027a.995.995 0 0 0-.933.986v.109c0 .475.344.884.819.971.263.049.462.155.663.352.259.256.37.519.37.88 0 .319-.123.605-.368.879-.26.255-.528.363-.812.367l-.332-.027a.986.986 0 1 0-.457 1.902c.149.059.264.138.434.319.242.225.358.495.374.782-.017.357-.115.625-.323.861l-.092.109a1.237 1.237 0 0 1-.848.321c-.065 0-.123.025-.185.037-.494-.101-.992.159-1.155.639a.983.983 0 0 0 .48 1.185c.062.047.26.207.675.616.282.277.397.54.398.855-.018.339-.108.613-.276.837l-.122.12c-.282.277-.548.39-.921.39l-15.386.005c-1.358-.127-2.52-.509-3.486-1.109V18.9c3.182-1.699 5.597-4.894 7.164-9.547a.915.915 0 0 0 .034-.132l.94-5.034c.014-.074.019-.176.016-.252-.014-.283.066-.478.31-.719.183-.194.404-.274.78-.259.291-.013.487.066.707.282.165.162.262.339.298.506l.708 4.716c-.001 2.441-.038 3.336-.049 3.457a3.831 3.831 0 0 1-1.151 2.327.977.977 0 0 0-.218 1.077c.155.37.522.611.928.611H32.45c.579 0 1.015.102 1.197.282a1.1 1.1 0 0 1 .314.567c0 .891.002 1.266.022 1.487-.029.33-.143.588-.337.793z" /
    >
    <
    /svg>
  );
};

export const GiftIcon = props => {
  const {
    className,
    onClick
  } = props;

  return ( <
    svg className = {
      className
    }
    onClick = {
      onClick
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "41.348"
    height = "45.317" >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M30.006 7.257h-4.501c.063-.338.105-.685.105-1.05 0-1.462-.509-2.725-1.511-3.753-.967-.993-2.181-1.496-3.608-1.496-1.429 0-2.656.499-3.695 1.533-.19.215-.355.439-.507.666a6.444 6.444 0 0 0-.563-.703C14.759 1.461 13.545.958 12.12.958c-1.443 0-2.666.503-3.646 1.507C7.497 3.5 7.001 4.759 7.001 6.207c0 .365.042.712.106 1.05H2.389c-.077 0-.145.028-.217.045-.073-.017-.141-.045-.218-.045a1 1 0 0 0-.988 1.012v6.019a1 1 0 0 0 .988 1.013h1.975v13.311c0 3.404 1.843 5.298 5.2 5.332H23.03c3.314-.034 5.158-1.924 5.191-5.332V15.301h1.785a1 1 0 0 0 .987-1.013V8.269a1 1 0 0 0-.987-1.012zm-12.661-1.12c-.016-.232.01-.478.078-.755.146-.558.42-1.06.792-1.485.629-.624 1.353-.915 2.276-.915.896 0 1.619.296 2.211.903.636.653.933 1.391.933 2.322 0 .385-.074.728-.181 1.05h-5.961c-.022-.065-.048-.134-.062-.193-.076-.332-.102-.574-.087-.783a.989.989 0 0 0 .001-.144zM9.882 3.886c.593-.608 1.325-.904 2.238-.904.907 0 1.609.287 2.193.886.447.481.734.976.871 1.495.055.225.08.494.08.844 0 .326-.027.607-.079.84-.018.071-.045.14-.07.21H9.157a3.272 3.272 0 0 1-.181-1.05c0-.917.3-1.68.906-2.321zM5.904 28.612V15.301h9.033v16.618H9.139c-2.268-.023-3.235-1.012-3.235-3.307zm17.116 3.307h-6.108V15.301h9.334v13.301c-.023 2.333-.961 3.294-3.226 3.317zm5.998-18.643H2.941V9.281h26.077v3.995z" /
    >
    <
    /svg>
  );
};

export const LoginChainIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "70px"
    height = "70px"
    viewBox = "0 0 85 85" >
    <
    path fill = "none"
    stroke = "#CDCCCC"
    d = "M41.5.5c22.644 0 41 18.356 41 41s-18.356 41-41 41-41-18.356-41-41 18.356-41 41-41z" /
    >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M50.035 52.5c-2.16 0-4.179-.547-5.905-1.496l-.006-.003c-.09-.049-.179-.1-.268-.152l-.04-.024c-.05-.029-.102-.058-.152-.089l.002-.002c-2.825-1.72-3.822-3.896-3.822-3.896a9.754 9.754 0 0 1-1.295-4.844c0-1.736.464-3.372 1.278-4.815.357.366.671.762.94 1.182a8.503 8.503 0 0 0-.817 3.633c0 1.299.297 2.537.83 3.659 1.231 2.455 3.823 4.107 3.823 4.107a10.704 10.704 0 0 0 5.432 1.459c5.56 0 10.084-4.138 10.084-9.225s-4.524-9.225-10.084-9.225c-2.012 0-3.886.543-5.461 1.475a12.88 12.88 0 0 0-.941-.974c1.83-1.126 4.032-1.783 6.402-1.783 6.343 0 11.485 4.704 11.485 10.507 0 5.802-5.142 10.506-11.485 10.506zm-5.875-5.807a8.749 8.749 0 0 1-.912-1.086 8.541 8.541 0 0 0 .792-3.592c0-3.469-2.094-6.497-5.186-8.086 0 0-1.525-1.166-4.937-1.184h-.011c-5.587 0-10.078 4.158-10.078 9.27 0 5.112 4.491 9.271 10.078 9.271 2.003 0 3.87-.537 5.444-1.458.26.294.56.602.899.915a12.16 12.16 0 0 1-6.343 1.757c-6.319 0-11.406-4.703-11.406-10.485 0-5.664 4.879-10.29 11.02-10.477 4.97.105 6.306 1.501 6.306 1.501 3.319 1.84 5.542 5.175 5.542 8.976a9.704 9.704 0 0 1-1.208 4.678z" /
    >
    <
    /svg>
  );
};

export const RingsIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "34.658"
    height = "19.994" >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M18.356 14.188a8.15 8.15 0 0 1-3.936-.998 10.336 10.336 0 0 1-.209-.119l-.102-.06.002-.001c-1.884-1.147-2.549-2.597-2.549-2.597a6.504 6.504 0 0 1-.862-3.23c0-1.157.308-2.247.852-3.209.237.243.447.507.626.788a5.662 5.662 0 0 0 .009 4.861c.821 1.636 2.548 2.738 2.548 2.738a7.135 7.135 0 0 0 3.621.973c3.708 0 6.723-2.759 6.723-6.151 0-3.391-3.015-6.149-6.723-6.149-1.34 0-2.59.362-3.64.983a8.923 8.923 0 0 0-.627-.65A8.13 8.13 0 0 1 18.356.179c4.229 0 7.657 3.136 7.657 7.004 0 3.869-3.428 7.005-7.657 7.005zm-3.916-3.872a5.784 5.784 0 0 1-.608-.724c.34-.737.528-1.546.528-2.395 0-2.312-1.396-4.331-3.457-5.39 0 0-1.017-.778-3.292-.789h-.007C3.88 1.018.886 3.79.886 7.197c0 3.409 2.994 6.181 6.718 6.181 1.335 0 2.58-.357 3.629-.971.174.195.374.401.6.609a8.103 8.103 0 0 1-4.229 1.172C3.391 14.188 0 11.052 0 7.197 0 3.422 3.252.338 7.347.213c3.313.07 4.204 1.001 4.204 1.001 2.212 1.226 3.695 3.449 3.695 5.983a6.47 6.47 0 0 1-.806 3.119z" /
    >
    <
    /svg>
  );
};

export const FormIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "18.671"
    height = "28.006" >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M6.87 15.748l-2.3 2.656a.501.501 0 0 1-.71.05L2.584 17.34a.509.509 0 0 1-.051-.716.501.501 0 0 1 .711-.052l.897.782 1.968-2.273a.502.502 0 0 1 .712-.049.51.51 0 0 1 .049.716zm-2.3-4.302a.501.501 0 0 1-.71.05l-1.276-1.114a.509.509 0 0 1-.051-.716.501.501 0 0 1 .711-.052l.897.782 1.968-2.273a.502.502 0 0 1 .712-.049.51.51 0 0 1 .049.716l-2.3 2.656zm2.3.864l-2.3 2.656a.501.501 0 0 1-.71.05l-1.276-1.114a.509.509 0 0 1-.051-.716.501.501 0 0 1 .711-.052l.897.782 1.968-2.273a.501.501 0 0 1 .712-.049.51.51 0 0 1 .049.716zm6.629 1.532c.278 0 .504.228.504.508v6.113c0 .28-.226.508-.504.508h-13a.506.506 0 0 1-.504-.508V4.091c0-.281.225-.508.504-.508H3.39a2.28 2.28 0 0 1 .254-.308 2.101 2.101 0 0 1 1.318-.625l.002-.009c.043-.24.143-.491.289-.719.083-.12.174-.231.271-.334.423-.42.926-.627 1.508-.627.522 0 .977.167 1.352.494.054.049.097.087.135.126.307.304.504.666.583 1.076.477.058.896.264 1.249.615.098.098.181.203.257.311h2.891c.278 0 .504.227.504.508v6.166a.506.506 0 0 1-.504.508.506.506 0 0 1-.505-.508V4.599h-2.018c.008.079.022.155.022.237 0 .611-.218 1.134-.649 1.556a.503.503 0 0 1-.352.144H4.001a.503.503 0 0 1-.352-.144A2.102 2.102 0 0 1 3 4.836c0-.082.014-.158.022-.237H1.003v15.356h11.991V14.35c0-.28.226-.508.505-.508zM4.225 5.52h5.548a1.09 1.09 0 0 0 .216-.684c0-.331-.114-.606-.348-.843-.24-.238-.522-.338-.864-.337-.033 0-.066 0-.097.003a.494.494 0 0 1-.384-.132.51.51 0 0 1-.163-.374v-.066c0-.316-.104-.566-.327-.788a1.165 1.165 0 0 0-.077-.07 1.006 1.006 0 0 0-.697-.251c-.316 0-.567.102-.788.321a1.591 1.591 0 0 0-.152.188 1.031 1.031 0 0 0-.142.365l-.1.42a.508.508 0 0 1-.531.387c-.043-.004-.089-.003-.135-.003-.328 0-.599.111-.829.34a1.141 1.141 0 0 0-.346.84c0 .267.069.489.216.684z" /
    >
    <
    /svg>
  );
};

export const CirclesIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "34.658"
    height = "26.683" >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M24.878 13.289c-.745-.76-1.665-1.145-2.734-1.145-.696 0-1.327.166-1.89.49l-4.716-4.479c.176-.134.348-.279.509-.443.859-.874 1.294-1.953 1.294-3.207 0-1.242-.435-2.314-1.294-3.188C15.19.443 14.131 0 12.899 0c-1.231 0-2.289.443-3.147 1.317-.85.866-1.291 1.935-1.311 3.197.02 1.257.461 2.333 1.311 3.198.111.112.225.217.343.316L5.64 12.567a3.746 3.746 0 0 0-1.77-.423 3.7 3.7 0 0 0-2.733 1.145C.4 14.039.017 14.967 0 16.066c.017 1.091.4 2.025 1.137 2.775.735.75 1.652 1.14 2.744 1.159 1.071-.019 1.987-.409 2.722-1.159.746-.758 1.124-1.694 1.124-2.784 0-1.08-.378-2.011-1.123-2.768l-.021-.019 4.524-4.61a4.547 4.547 0 0 0 1.801.387 4.6 4.6 0 0 0 1.564-.296l4.865 4.62c-.687.736-1.047 1.636-1.064 2.695.018 1.091.401 2.024 1.138 2.774.735.751 1.651 1.141 2.744 1.16 1.071-.019 1.987-.409 2.722-1.159.746-.757 1.123-1.694 1.123-2.784 0-1.08-.377-2.011-1.122-2.768zm-19.091 4.72a2.63 2.63 0 0 1-1.906.815c-.773-.014-1.403-.281-1.927-.815-.526-.535-.787-1.176-.799-1.943.012-.785.266-1.403.799-1.945v-.001c.528-.538 1.155-.8 1.916-.8.762 0 1.389.262 1.918.801.528.536.784 1.17.784 1.936 0 .776-.256 1.415-.785 1.952zM10.569 6.88c-.64-.651-.958-1.431-.973-2.366.015-.94.333-1.714.973-2.365.642-.654 1.404-.973 2.33-.973.927 0 1.69.319 2.332.973.643.655.955 1.425.955 2.356 0 .944-.312 1.72-.955 2.375-.64.651-1.406.975-2.323.99-.934-.015-1.699-.339-2.339-.99zm13.492 11.129a2.63 2.63 0 0 1-1.906.815c-.773-.014-1.403-.281-1.927-.815-.526-.535-.787-1.177-.8-1.943.013-.785.266-1.403.8-1.945v-.001c.528-.538 1.155-.8 1.916-.8.762 0 1.389.262 1.918.801.527.536.784 1.169.784 1.936 0 .777-.257 1.415-.785 1.952z" /
    >
    <
    /svg>
  );
};

export const SignupIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "26.683" >
    <
    path fill = "#EF3024"
    fillRule = "evenodd"
    d = "M18.982 8.227l-3.297 3.469a.798.798 0 0 1-1.206.037.874.874 0 0 1 0-1.255l3.298-3.469a.552.552 0 0 0 0-.775l-4.042-4.281a.501.501 0 0 0-.745 0L9.693 5.422a.794.794 0 0 1-1.205 0 .871.871 0 0 1 0-1.254l3.297-3.47a2.215 2.215 0 0 1 1.595-.701c.603 0 1.17.259 1.596.701l4.006 4.245c.851.922.851 2.398 0 3.284zm-6.311-.886a.873.873 0 0 1 0 1.255l-3.899 4.097c-.178.184-.39.295-.639.295a.815.815 0 0 1-.602-.258.873.873 0 0 1 0-1.255l3.935-4.134a.794.794 0 0 1 1.205 0zm-.921 7.234a.874.874 0 0 1 0 1.255l-3.298 3.469c-.39.479-.992.701-1.595.701a2.21 2.21 0 0 1-1.595-.701l-4.006-4.244c-.851-.923-.851-2.399 0-3.285l3.297-3.469a.794.794 0 0 1 1.205 0 .873.873 0 0 1 0 1.255l-3.297 3.469a.55.55 0 0 0 0 .775l4.042 4.244a.5.5 0 0 0 .744 0l3.297-3.469a.795.795 0 0 1 1.206 0z" /
    >
    <
    /svg>
  );
};

export const LockIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "18.671"
    height = "26.683" >
    <
    path fill = "#EF3024"
    fillRule = "evenodd"
    d = "M10.752 5.71H4.051V3.941c0-1.361 1.061-2.518 2.455-2.518h.862c.996 0 1.858.612 2.256 1.497.133.34.531.476.863.34.332-.136.464-.544.332-.884C10.221.947 8.894-.006 7.368-.006h-.862c-2.057 0-3.783 1.701-3.783 3.879V5.71C1.197 5.982.003 7.411.003 9.044v7.553c0 1.905 1.46 3.402 3.318 3.402h7.365c1.858 0 3.318-1.497 3.318-3.402V9.112a3.274 3.274 0 0 0-3.252-3.402zm1.991 10.955c0 1.156-.863 2.041-1.991 2.041H3.321c-1.128 0-1.991-.885-1.991-2.041V9.112c0-1.157.863-2.041 1.991-2.041h7.365c1.128 0 1.991.884 1.991 2.041v7.553h.066zm-4.711-4.899c0 .272-.133.544-.332.748v1.565c0 .408-.265.68-.664.68-.398 0-.663-.272-.663-.68v-1.565c-.199-.204-.332-.476-.332-.748 0-.545.465-1.021.995-1.021.531 0 .996.476.996 1.021z" /
    >
    <
    /svg>
  );
};

export const MessageIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "21px"
    height = "17.348" >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M20.119 10.149c-.01.703-.308 1.882-2.197 1.882H2.324C.721 12.014.256 11.182.147 10.487a2.391 2.391 0 0 1-.018-.344V1.917C.129 1.395.26.989.53.674c.264-.305.786-.66 1.802-.645h15.59c.238-.013.492.011.723.071.174.033.345.087.51.163a.748.748 0 0 1 .28.231.46.46 0 0 1 .168.088c.036.029.11.089.167.187.216.294.333.675.348 1.133l.001 8.241-.001.002.001.004zm-17.789.96h15.592c.882 0 1.131-.322 1.199-.716l-7.047-3.846-.405.338a.496.496 0 0 1-.046.034.478.478 0 0 1-.067.06c-.309.23-.621.387-.925.468a2.198 2.198 0 0 1-.498.059c-.511 0-1.002-.192-1.47-.573l-.489-.407-7.058 3.872c.068.367.276.701 1.214.711zM1.095 9.346l6.259-3.434-6.195-4.421a1.332 1.332 0 0 0-.064.426v7.429zM17.946.95L2.324.951a2.988 2.988 0 0 0-.294.011l6.491 4.631c.003.003.002.007.005.01l.009.004c.004.004.01.004.014.008l.744.619c.494.401.861.375 1.093.321.158-.042.343-.136.538-.275a.724.724 0 0 1 .137-.113l.637-.53.014-.007.008-.005c.003-.002.002-.007.006-.01L18.219.977c-.09-.011-.18-.032-.273-.027zm1.206.967a1.368 1.368 0 0 0-.072-.404l-6.186 4.42 6.258 3.415V1.917z" /
    >
    <
    /svg>
  );
};

export const PhoneIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "15.987"
    height = "28.006" >
    <
    path className = {
      className
    }
    fill = "#EFC874"
    fillRule = "evenodd"
    d = "M11.929 19.461a2.217 2.217 0 0 1-.162.509.753.753 0 0 1-.239.298.471.471 0 0 1-.081.151.672.672 0 0 1-.187.167c-.294.215-.675.332-1.133.348H1.881c-.703-.01-1.883-.308-1.883-2.196V3.137C.015 1.533.847 1.068 1.542.959c.112-.016.221-.018.345-.018h8.225c.522 0 .928.131 1.244.401.304.264.659.786.645 1.803v15.593a2.45 2.45 0 0 1-.072.723zm-.851-16.324c.005-.355-.043-.818-.308-1.049-.142-.121-.358-.181-.658-.181H1.887c-.077 0-.144-.002-.212.009-.385.06-.744.25-.755 1.226v15.596c0 1.069.468 1.223.973 1.23h8.219c.27-.009.489-.071.633-.184l.028-.02c.011-.011.026-.016.039-.025a.477.477 0 0 1 .138-.221c.038-.09.062-.175.083-.28.041-.163.054-.314.046-.476l-.001-15.625zM9.393 17.261H2.61a.529.529 0 0 1-.516-.539V3.849a.53.53 0 0 1 .516-.54h6.783c.284 0 .515.242.515.54v12.873a.528.528 0 0 1-.515.539zm.054-13.412c0-.031-.025-.057-.054-.057H2.61a.057.057 0 0 0-.055.057v12.873c0 .031.025.056.055.056h6.783a.056.056 0 0 0 .054-.056V3.849zM6.352 17.983a.54.54 0 0 1 0 .739.496.496 0 0 1-.351.152.499.499 0 0 1-.353-.152.543.543 0 0 1 0-.739.499.499 0 0 1 .704 0z" /
    >
    <
    /svg>
  );
};

export const HomePhoneIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "20px"
    height = "20px" >
    <
    path className = {
      className
    }
    fill = "#040707"
    fillRule = "evenodd"
    d = "M15.104 1.03a.56.56 0 0 1 .405.155l.015.016.016.014 2.256 2.067c.453.477.283 2.111-.412 3.973-.865 2.312-2.356 4.653-4.199 6.593-3.159 3.324-7.047 5.118-9.102 5.118-.442 0-.775-.094-.933-.26l-1.969-2.38-.014-.017-.015-.016c-.231-.257-.193-.736.073-1.018l2.803-2.336.031-.026.028-.028a.617.617 0 0 1 .438-.18c.174 0 .331.068.441.181l.743 1.175.389.615.679-.19c.885-.249 2.35-1.399 4.018-3.154 2.304-2.425 2.869-3.695 3.001-4.237l.172-.708-.578-.405-1.102-.769a.708.708 0 0 1-.017-.939l.026-.03.024-.032 2.214-2.941a.795.795 0 0 1 .569-.241m0-1.03a1.743 1.743 0 0 0-1.329.622l-2.221 2.95a1.777 1.777 0 0 0 .041 2.369.98.98 0 0 0 .134.115l1.119.783c-.104.425-.709 1.622-2.745 3.764-2.021 2.127-3.169 2.772-3.579 2.887l-.743-1.175a.99.99 0 0 0-.109-.14 1.575 1.575 0 0 0-1.147-.5c-.413 0-.803.162-1.104.456L.617 14.468a.844.844 0 0 0-.075.072c-.652.686-.693 1.804-.099 2.462l1.969 2.38a.92.92 0 0 0 .041.047c.358.376.907.567 1.63.567h.001c2.307 0 6.412-1.862 9.793-5.42 1.936-2.038 3.505-4.503 4.417-6.944.426-1.14 1.298-3.916.194-5.078a.597.597 0 0 0-.043-.044L16.183.438A1.512 1.512 0 0 0 15.104 0z" /
    >
    <
    /svg>
  );
};

export const ClipboardIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "125px"
    height = "125px"
    viewBox = "0 0 125 125"

    >
    <
    path fill = "none"
    stroke = "#CDCCCC"
    d = "M60.5.5c33.137 0 60 26.863 60 60s-26.863 60-60 60-60-26.863-60-60 26.863-60 60-60z" /
    >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M60.675 72.388l-5.749 6.633a1.257 1.257 0 0 1-1.775.125l-3.192-2.782a1.274 1.274 0 0 1-.128-1.789 1.254 1.254 0 0 1 1.778-.129l2.242 1.953 4.923-5.679a1.256 1.256 0 0 1 1.779-.123c.524.461.578 1.263.122 1.791zm-5.749-10.749a1.255 1.255 0 0 1-1.775.125l-3.192-2.78a1.276 1.276 0 0 1-.128-1.791 1.254 1.254 0 0 1 1.778-.128l2.242 1.953 4.923-5.68a1.256 1.256 0 0 1 1.779-.122c.524.461.578 1.263.122 1.791l-5.749 6.632zm5.749 2.161l-5.749 6.632a1.255 1.255 0 0 1-1.775.126l-3.192-2.782a1.274 1.274 0 0 1-.128-1.789 1.253 1.253 0 0 1 1.778-.129l2.242 1.953 4.923-5.68a1.256 1.256 0 0 1 1.779-.122c.524.46.578 1.262.122 1.791zm16.572 3.826c.697 0 1.26.568 1.26 1.269v15.269c0 .701-.563 1.269-1.26 1.269H44.748a1.265 1.265 0 0 1-1.261-1.269V43.267c0-.701.564-1.269 1.261-1.269h7.227c.187-.267.394-.526.635-.77.927-.921 2.033-1.444 3.295-1.561l.006-.022a4.985 4.985 0 0 1 .723-1.794 6.83 6.83 0 0 1 .676-.837c1.057-1.049 2.314-1.564 3.77-1.564 1.306 0 2.442.415 3.379 1.234.137.12.244.217.338.312.769.762 1.259 1.665 1.457 2.689 1.192.146 2.241.661 3.124 1.537.244.246.452.507.641.776h7.228c.697 0 1.26.568 1.26 1.269v15.404c0 .701-.563 1.268-1.26 1.268a1.264 1.264 0 0 1-1.261-1.268V44.536H70.94c.02.197.055.388.055.592 0 1.526-.546 2.834-1.623 3.887-.235.231-.551.36-.879.36H53.502c-.329 0-.644-.129-.879-.36C51.545 47.962 51 46.654 51 45.128c0-.204.035-.395.055-.592h-5.047v38.359h29.978v-14c0-.701.564-1.269 1.261-1.269zM54.063 46.837h13.868c.368-.488.542-1.041.542-1.709 0-.825-.286-1.514-.872-2.104-.599-.595-1.303-.845-2.159-.843-.083 0-.165 0-.243.007a1.231 1.231 0 0 1-.959-.33 1.274 1.274 0 0 1-.407-.935v-.164c0-.789-.26-1.414-.819-1.967-.068-.069-.129-.122-.191-.177-.489-.427-1.053-.627-1.743-.627-.791 0-1.417.255-1.969.803a3.906 3.906 0 0 0-.38.469c-.17.264-.292.573-.355.913l-.25 1.048a1.27 1.27 0 0 1-1.33.967c-.106-.009-.221-.007-.336-.007-.82 0-1.498.277-2.073.849a2.852 2.852 0 0 0-.866 2.098c0 .668.174 1.221.542 1.709z" /
    >
    <
    /svg>
  );
};

export const Favorite = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = ".67cm" >
    <
    path fill = "#EF3024"
    fillRule = "evenodd"
    d = "M19.357 2.575C18.309 1.488 17.019.938 15.526.938c-1.495 0-2.784.55-3.833 1.637a5.949 5.949 0 0 0-.743.939 6.172 6.172 0 0 0-.747-.939C9.155 1.488 7.866.938 6.371.938c-1.494 0-2.783.55-3.832 1.637C1.48 3.672.943 5.008.943 6.545c0 .871.172 1.676.504 2.381.206.463.478.898.809 1.294.005.006.012.008.017.013.005.006.006.013.011.018 1.855 1.9 3.703 3.807 5.552 5.717l2.725 2.811c.032.032.07.05.106.072.026.016.048.04.075.052a.545.545 0 0 0 .413-.001c.028-.011.05-.035.076-.052.036-.023.074-.04.105-.072l.138-.143c2.703-2.8 5.405-5.599 8.151-8.415.314-.375.589-.805.824-1.292a5.785 5.785 0 0 0 .489-2.383c0-1.548-.532-2.883-1.581-3.97z" /
    >
    <
    /svg>
  );
};

export const FavoriteOutline = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = ".67cm" >
    <
    path fill = "#EF3024"
    fillRule = "evenodd"
    d = "M19.357 2.575C18.309 1.488 17.019.937 15.526.937c-1.495 0-2.784.551-3.833 1.638a5.949 5.949 0 0 0-.743.939 6.172 6.172 0 0 0-.747-.939C9.155 1.488 7.866.937 6.371.937c-1.494 0-2.783.551-3.832 1.638C1.48 3.672.943 5.008.943 6.545c0 .871.172 1.676.504 2.381.206.463.478.898.809 1.294.005.006.012.008.017.013.005.006.006.013.011.018 1.855 1.9 3.703 3.807 5.552 5.717l2.725 2.811c.032.032.07.05.106.072.026.016.048.04.075.052a.545.545 0 0 0 .413-.001c.028-.011.05-.035.076-.052.036-.023.074-.04.105-.072l.138-.143c2.703-2.8 5.405-5.599 8.151-8.415.314-.375.589-.805.824-1.292a5.785 5.785 0 0 0 .489-2.383c0-1.548-.532-2.883-1.581-3.97zm.103 5.86a4.924 4.924 0 0 1-.635 1.008c-2.635 2.7-5.256 5.415-7.877 8.13l-2.337-2.411C6.768 13.26 4.927 11.36 3.08 9.467a4.37 4.37 0 0 1-.642-1.028c-.263-.56-.397-1.197-.397-1.894 0-1.242.417-2.278 1.274-3.166.847-.878 1.847-1.304 3.056-1.304s2.209.426 3.056 1.304c.446.461.784.973 1.034 1.563a.568.568 0 0 0 .513.341.55.55 0 0 0 .5-.363c.21-.555.544-1.074.995-1.541.847-.878 1.847-1.304 3.057-1.304 1.209 0 2.208.426 3.055 1.304.848.878 1.26 1.913 1.26 3.166 0 .689-.13 1.33-.381 1.89z" /
    >
    <
    /svg>
  );
};

export const ExitIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = ".67cm"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M18.057 18.937H9.2c-1.279 0-2.012-.697-2.012-1.912v-4.079c0-.281.24-.509.537-.509.296 0 .536.228.536.509v4.079c0 .66.245.893.939.893h8.857c.694 0 .939-.233.939-.893V2.855c0-.659-.245-.893-.939-.893H9.2c-.694 0-.939.234-.939.893v3.784c0 .281-.24.509-.536.509a.523.523 0 0 1-.537-.509V2.855C7.188 1.64 7.921.944 9.2.944h8.857c1.279 0 2.012.696 2.012 1.911v14.17c0 1.215-.733 1.912-2.012 1.912zM1.903 9.452h11.982c.296 0 .536.228.536.509s-.24.509-.536.509H1.959l2.684 2.385a.492.492 0 0 1 .025.72.55.55 0 0 1-.392.161.553.553 0 0 1-.367-.137L.234 10.333l-.003-.005c-.003-.004-.008-.005-.011-.008v-.001l-.001-.001a.497.497 0 0 1-.155-.357c0-.13.055-.246.14-.336.003-.003.001-.009.005-.012a.008.008 0 0 1 .005-.002L.222 9.6l.001-.001 3.424-3.223a.556.556 0 0 1 .758.003.49.49 0 0 1-.003.72L1.903 9.452z" /
    >
    <
    /svg>
  );
};

export const HomeIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "21.317"
    height = "33.335"
    className = {
      className
    } >
    <
    path fill = "#E5BF6F"
    fillRule = "evenodd"
    d = "M8.069 20.78a.323.323 0 0 1-.21-.076c-1.936-1.64-2.872-2.588-2.95-3.546l-.001-.021v-.31l.001-.023c.092-1.1.876-1.669 1.565-1.731.1-.011.197-.015.289-.015.506 0 .983.277 1.3.723.289-.412.746-.723 1.314-.723.09 0 .186.004.288.015.689.062 1.473.631 1.566 1.731v.354c-.076.91-.988 2.005-2.96 3.554a.337.337 0 0 1-.202.068zm2.531-3.657v-.283c-.068-.75-.563-1.134-.997-1.174a2.259 2.259 0 0 0-.226-.011c-.514 0-.899.479-.998.929a.313.313 0 0 1-.303.236.308.308 0 0 1-.312-.224c-.123-.453-.489-.941-1.001-.941-.072 0-.147.003-.228.011-.433.04-.929.424-.997 1.174v.283c.076.78 1.177 1.803 2.538 2.963 1.634-1.305 2.46-2.276 2.524-2.963zM8.064 6.26l3.147-3.139.496.444-3.643 3.627-3.642-3.627.494-.444L8.064 6.26zm.085 4.832l-.132-.004-.007-.001c-3.812 0-6.914 2.931-6.914 6.533 0 3.602 3.102 6.534 6.914 6.534s6.914-2.932 6.914-6.534c0-2.444-1.429-4.579-3.538-5.699l.663-.628c2.264 1.297 3.781 3.648 3.781 6.327 0 4.075-3.508 7.39-7.82 7.39S.19 21.695.19 17.62c0-3.992 3.366-7.252 7.557-7.384l7.014-6.981L12.465.85h-8.63L1.282 3.263l4.785 4.522-.623.621L0 3.263 3.459-.006h9.41l3.128 3.276-7.848 7.822z" /
    >
    <
    /svg>
  );
};

export const EventIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "26.683"
    height = "28.006"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M19.422 11.816l-9.171 9.154-7.787-1.049c-.76-.116-1.256-.619-1.373-1.381l-1.099-7.825L9.159 1.55c.39-.391.808-.59 1.244-.59.434 0 .853.199 1.244.59l7.77 7.784c.769.792.769 1.695.005 2.482zm-.79-1.709l-7.765-7.778c-.121-.122-.3-.267-.464-.267-.165 0-.343.145-.464.267L1.16 11.106l1.022 7.274c.043.284.162.408.439.45l7.238.974 8.779-8.762c.339-.35.339-.579-.006-.935zM5.924 17.015a1.85 1.85 0 0 1-1.354-.558 1.874 1.874 0 0 1-.558-1.354c0-.53.187-.986.558-1.356.38-.379.836-.572 1.354-.572.519 0 .975.193 1.356.573.357.357.55.805.572 1.332-.022.565-.221 1.026-.572 1.377-.37.37-.827.558-1.356.558zm.577-2.487a.767.767 0 0 0-.577-.251.764.764 0 0 0-.575.25l-.001.001a.755.755 0 0 0-.234.575c0 .229.077.417.235.575a.756.756 0 0 0 .575.235c.24 0 .412-.07.576-.235a.855.855 0 0 0 .25-.599.809.809 0 0 0-.249-.551z" /
    >
    <
    /svg>
  );
};

export const CheckListIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "34.658"
    height = ".6cm"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M10.146 16.237c-.49 0-.964-.19-1.406-.563L1.043 9.186c-.893-.752-.894-1.616 0-2.37l2.035-1.714c.883-.746 1.927-.747 2.813 0l4.34 3.645L19.854.783c.876-.74 1.922-.744 2.808.003l2.035 1.715c.893.753.893 1.617 0 2.37l-13.15 10.808c-.438.368-.91.558-1.401.558zM4.485 5.544c-.203 0-.418.146-.563.268L1.886 7.527c-.425.359-.426.59 0 .949l7.697 6.488c.145.122.36.268.563.268.203 0 .418-.146.563-.268l13.15-10.808c.415-.35.415-.59-.006-.945l-2.034-1.715c-.145-.122-.361-.267-.563-.267-.203 0-.418.145-.563.267L10.646 9.812a.677.677 0 0 1-.839-.002L5.048 5.813c-.145-.123-.361-.269-.563-.269z" /
    >
    <
    /svg>
  );
};

export const ProvidersIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "18.671"
    height = "28.006"
    className = {
      className
    } >
    <
    path fill = "#E5BF6F"
    fillRule = "evenodd"
    d = "M6.87 15.672l-2.3 2.657a.5.5 0 0 1-.71.05l-1.276-1.114a.51.51 0 0 1-.051-.717.501.501 0 0 1 .711-.052l.897.783 1.968-2.275a.502.502 0 0 1 .712-.049c.21.185.232.506.049.717zm-2.3-4.304a.5.5 0 0 1-.71.05l-1.276-1.114a.51.51 0 0 1-.051-.717.5.5 0 0 1 .711-.051l.897.782 1.968-2.275a.503.503 0 0 1 .712-.049c.21.185.232.506.049.717l-2.3 2.657zm2.3.865l-2.3 2.656a.5.5 0 0 1-.71.05l-1.276-1.114a.509.509 0 0 1-.051-.716.5.5 0 0 1 .711-.052l.897.782 1.968-2.274a.501.501 0 0 1 .712-.049.51.51 0 0 1 .049.717zm6.629 1.532c.278 0 .504.228.504.508v6.115a.507.507 0 0 1-.504.509h-13a.506.506 0 0 1-.504-.509V4.01c0-.281.225-.508.504-.508H3.39a2.28 2.28 0 0 1 .254-.308c.371-.37.813-.579 1.318-.626l.002-.009c.043-.24.143-.49.29-.718a2.69 2.69 0 0 1 .27-.335c.423-.42.926-.627 1.508-.627.522 0 .977.166 1.352.494.054.049.097.087.135.126.308.305.504.666.583 1.076a2.1 2.1 0 0 1 1.249.616c.098.098.181.203.257.311h2.891c.278 0 .504.227.504.508v6.169c0 .28-.226.508-.504.508a.507.507 0 0 1-.505-.508V4.518h-2.018c.008.079.022.155.022.237 0 .611-.218 1.135-.649 1.557a.499.499 0 0 1-.352.144H4.001a.499.499 0 0 1-.352-.144A2.104 2.104 0 0 1 3 4.755c0-.082.014-.158.022-.237H1.003V19.88h11.991v-5.607c0-.28.226-.508.505-.508zM4.225 5.439h5.548c.147-.195.216-.416.216-.684 0-.33-.114-.606-.348-.843-.24-.238-.522-.338-.864-.337-.033 0-.066 0-.097.003a.494.494 0 0 1-.384-.132.513.513 0 0 1-.163-.375v-.065c0-.317-.104-.567-.327-.788-.027-.028-.052-.049-.077-.071a1.006 1.006 0 0 0-.697-.251c-.316 0-.567.102-.788.321-.048.052-.105.12-.152.188a1.029 1.029 0 0 0-.142.366l-.1.419a.508.508 0 0 1-.531.388c-.043-.004-.089-.003-.135-.003-.328 0-.599.111-.829.34-.232.234-.346.51-.346.84 0 .268.069.489.216.684z" /
    >
    <
    /svg>
  );
};

export const FavoritesIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = ".67cm"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M19.357 2.575C18.309 1.488 17.019.937 15.525.937c-1.494 0-2.783.551-3.832 1.638a5.949 5.949 0 0 0-.743.939 6.172 6.172 0 0 0-.747-.939C9.155 1.488 7.866.937 6.371.937c-1.494 0-2.783.551-3.832 1.638C1.48 3.672.943 5.008.943 6.545c0 .871.172 1.676.504 2.381.206.463.478.898.809 1.294.005.006.012.008.017.013.005.006.006.013.011.018 1.855 1.9 3.703 3.807 5.552 5.717l2.725 2.811c.032.032.07.049.106.072.026.016.048.04.075.052a.545.545 0 0 0 .413-.001c.028-.011.05-.036.076-.052.036-.023.074-.04.105-.072l.138-.143c2.703-2.8 5.405-5.599 8.151-8.415.314-.374.589-.805.824-1.292a5.785 5.785 0 0 0 .489-2.383c0-1.548-.532-2.883-1.581-3.97zm.103 5.86a4.924 4.924 0 0 1-.635 1.008c-2.635 2.7-5.256 5.415-7.877 8.13l-2.337-2.411C6.768 13.26 4.927 11.36 3.08 9.467a4.37 4.37 0 0 1-.642-1.028c-.263-.56-.397-1.197-.397-1.894 0-1.242.417-2.278 1.274-3.166.847-.878 1.847-1.304 3.056-1.304s2.21.426 3.056 1.304c.446.461.784.973 1.034 1.563a.568.568 0 0 0 .514.341.552.552 0 0 0 .5-.363 4.51 4.51 0 0 1 .994-1.541c.847-.878 1.848-1.304 3.056-1.304 1.21 0 2.209.426 3.056 1.304.848.878 1.26 1.914 1.26 3.166 0 .69-.13 1.33-.381 1.89z" /
    >
    <
    /svg>
  );
};

export const BenefitsIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "29.329"
    height = "26.683"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M21.967 10.178c.002-.056.006-.065-.008-.12-.008-.077-.008-.421-.008-.82a.687.687 0 0 0-.008-.101 1.834 1.834 0 0 0-.518-.998c-.338-.337-.852-.507-1.527-.507H14.55c.155-.332.256-.69.302-1.075.021-.218.035-1.063.035-2.203a.607.607 0 0 0-.006-.085l-.425-2.847A1.776 1.776 0 0 0 13.957.5c-.363-.359-.792-.526-1.241-.506-.52-.024-.968.156-1.298.507-.35.348-.522.766-.511 1.231l-.53 2.862c-.765 2.273-1.878 3.869-3.314 4.762a1.305 1.305 0 0 0-.105-.12c-.163-.157-.46-.336-.931-.323H2.304c-.396-.012-.728.096-.968.326-.241.231-.363.554-.363.96v8.518c0 .794.503 1.287 1.312 1.287h3.742c.535 0 .937-.238 1.142-.633.617.298 1.321.493 2.132.568h9.032c.525 0 .985-.192 1.365-.569l.097-.096a.535.535 0 0 0 .045-.05c.264-.328.409-.725.434-1.211 0-.403-.119-.766-.347-1.086.13-.075.256-.16.372-.267a1.34 1.34 0 0 0 .051-.054l.071-.086c.285-.326.442-.73.465-1.254a1.948 1.948 0 0 0-.233-.869 2.057 2.057 0 0 0 .395-.323c.342-.388.516-.824.516-1.297 0-.423-.124-.801-.37-1.126.085-.06.167-.129.244-.206a1.93 1.93 0 0 0 .529-1.267zM6.151 18.717c0 .066-.009.101-.007.11a.394.394 0 0 1-.117.013H2.285c-.078 0-.121-.011-.127-.008a.381.381 0 0 1-.013-.115v-8.518c0-.065.008-.103.005-.116a.628.628 0 0 1 .135-.007h3.762l.027-.001c.032 0 .053.002.064.001a.49.49 0 0 1 .013.123v8.518zm14.445-8.08c-.123.122-.277.181-.514.182l-.226.016a.584.584 0 0 0-.544.581v.064c0 .28.201.52.478.572.153.028.269.09.387.207.151.15.215.305.215.518a.762.762 0 0 1-.214.517.667.667 0 0 1-.474.216l-.193-.016a.582.582 0 0 0-.267 1.12.644.644 0 0 1 .253.188.664.664 0 0 1 .218.46.777.777 0 0 1-.188.506l-.054.064a.714.714 0 0 1-.495.19c-.038 0-.071.015-.107.022a.578.578 0 0 0-.674.376.58.58 0 0 0 .28.697c.036.027.151.122.393.363.165.163.232.317.233.503a.883.883 0 0 1-.161.493l-.072.07a.698.698 0 0 1-.537.23l-8.977.003c-.792-.075-1.47-.3-2.033-.653v-7.585c1.856-1 3.265-2.88 4.179-5.619a.447.447 0 0 0 .02-.078l.549-2.963a.812.812 0 0 0 .009-.148c-.008-.167.039-.282.181-.424.106-.114.235-.161.455-.152a.497.497 0 0 1 .413.166.601.601 0 0 1 .173.298l.413 2.776c0 1.436-.022 1.963-.029 2.035-.062.53-.288.991-.671 1.37a.579.579 0 0 0-.127.634.588.588 0 0 0 .542.359h6.468c.338 0 .592.06.698.166a.652.652 0 0 1 .183.334c0 .524.001.745.013.875a.753.753 0 0 1-.196.467z" /
    >
    <
    /svg>
  );
};

export const RewardIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = ".67cm"
    height = "28.006"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M18.342 4.755h-2.698c.038-.204.063-.415.063-.637 0-.886-.305-1.652-.905-2.275-.58-.602-1.308-.908-2.163-.908-.856 0-1.592.303-2.215.93a3.81 3.81 0 0 0-.303.405 3.892 3.892 0 0 0-.337-.427c-.58-.602-1.308-.908-2.162-.908-.865 0-1.598.306-2.185.915-.586.627-.883 1.391-.883 2.268 0 .222.025.433.063.637H1.79c-.046 0-.087.017-.13.028-.044-.011-.085-.028-.131-.028a.603.603 0 0 0-.592.614v3.65c0 .339.265.614.592.614h1.184v8.073c0 2.065 1.105 3.213 3.117 3.234h8.331c1.986-.021 3.091-1.167 3.111-3.234V9.633h1.07a.603.603 0 0 0 .592-.614v-3.65a.603.603 0 0 0-.592-.614zm-7.589-.678c-.009-.142.007-.29.047-.459.088-.338.252-.642.475-.9.377-.378.811-.555 1.364-.555.537 0 .97.179 1.325.548.381.396.56.843.56 1.407 0 .234-.045.442-.109.637h-3.573c-.013-.039-.029-.081-.037-.116a1.654 1.654 0 0 1-.052-.475.631.631 0 0 0 0-.087zM6.28 2.711c.356-.368.795-.548 1.342-.548.544 0 .965.174 1.314.538.268.291.44.591.522.906.033.136.048.299.048.511 0 .198-.016.369-.047.51-.011.043-.027.085-.042.127H5.846a2.005 2.005 0 0 1-.108-.637c0-.555.18-1.018.542-1.407zM3.896 17.706V9.633H9.31v10.079H5.835c-1.359-.014-1.939-.614-1.939-2.006zm10.259 2.006h-3.661V9.633h5.594V17.7c-.014 1.415-.576 1.998-1.933 2.012zM17.75 8.406H2.121V5.983H17.75v2.423z" /
    >
    <
    /svg>
  );
};

export const IndicateIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = "28.006"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M18.655 20.906H3.287a2.321 2.321 0 0 1-2.319-2.318V3.219A2.32 2.32 0 0 1 3.285.901h8.62v1.305h-8.62c-.558 0-1.011.454-1.011 1.013v15.369c0 .559.454 1.013 1.013 1.013h15.368c.559 0 1.013-.455 1.013-1.014v-8.542h1.305v8.542a2.321 2.321 0 0 1-2.318 2.319zm1.637-15.023h-3.085v3.031a.697.697 0 0 1-.688.704.697.697 0 0 1-.689-.704V5.883h-2.869a.686.686 0 0 1-.681-.689c0-.379.306-.688.681-.688h2.869V1.629c0-.388.309-.704.689-.704.379 0 .688.316.688.704v2.877h3.085c.376 0 .681.309.681.688 0 .38-.305.689-.681.689z" /
    >
    <
    /svg>
  );
};

export const RatingIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "28.006"
    height = "28.006"
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M10.782 20.9c-5.514 0-10-4.486-10-10 0-5.513 4.486-9.999 10-9.999 5.513 0 9.999 4.486 9.999 9.999 0 5.514-4.486 10-9.999 10zm0-18.758c-4.829 0-8.757 3.929-8.757 8.758 0 4.829 3.928 8.758 8.757 8.758s8.757-3.929 8.757-8.758c0-4.829-3.928-8.758-8.757-8.758zm4.402 6.133l-.88.929-.871-.827 1.751-1.845 1.75 1.846-.871.826-.879-.929zm.296 3.613h.002a.63.63 0 0 1 .448 1.077 7.234 7.234 0 0 1-5.148 2.129 7.23 7.23 0 0 1-5.148-2.129.629.629 0 0 1 0-.894c.24-.24.655-.24.895 0a5.977 5.977 0 0 0 4.253 1.758 5.978 5.978 0 0 0 4.253-1.758.633.633 0 0 1 .445-.183zm-9.1-3.613l-.881.929-.87-.827L6.38 6.532l1.75 1.846-.871.826-.879-.929z" /
    >
    <
    /svg>
  );
};

export const MenuMobileSeparatorIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    width = "2.646cm"
    height = "21.317"
    className = {
      className
    } >
    <
    path fill = "#CDCCCC"
    fillRule = "evenodd"
    d = "M64.335 6.473c.068-.688.678-1.472 1.858-1.565h.38c1.027.079 2.045 1.015 3.806 2.951a.314.314 0 0 1 .008.412c-1.661 1.972-2.837 2.884-3.814 2.96h-.38c-1.18-.094-1.79-.877-1.858-1.566a2.701 2.701 0 0 1-.016-.288c0-.568.333-1.025.776-1.314-.478-.317-.776-.794-.776-1.3 0-.092.005-.189.016-.29zm1.634 1.291a.311.311 0 0 1 .241.312.316.316 0 0 1-.254.302c-.483.1-.996.485-.996.999 0 .071.003.145.011.226.044.434.456.929 1.261.997h.303c.737-.064 1.779-.89 3.181-2.524-1.246-1.361-2.343-2.462-3.181-2.538h-.304c-.804.068-1.216.564-1.26.997a2.298 2.298 0 0 0-.011.228c0 .512.524.878 1.009 1.001zM51.982 4.422l3.893 3.642-3.893 3.643-.476-.497 3.369-3.146-3.369-3.148.476-.494zM67.068 15.83a7.96 7.96 0 0 1-6.789-3.781l.672-.664a7.034 7.034 0 0 0 6.117 3.538c3.867 0 7.014-3.101 7.014-6.913 0-3.812-3.147-6.914-7.014-6.914-3.867 0-7.012 3.102-7.012 6.914l.001.007.006.132-8.396 7.847-3.517-3.128V3.459L51.659 0l5.521 5.444-.668.623-4.853-4.786-2.59 2.554v8.63l2.581 2.296 7.494-7.014c.14-4.191 3.64-7.557 7.924-7.557C71.442.19 75 3.698 75 8.01s-3.558 7.82-7.932 7.82zM29.58 7.274h15.841v1.447H29.58V7.274zM10.666 9.665c-.068.689-.678 1.472-1.858 1.566h-.38c-.977-.076-2.153-.988-3.815-2.96a.32.32 0 0 1-.073-.202.31.31 0 0 1 .082-.21C6.382 5.923 7.4 4.987 8.428 4.908h.38c1.18.093 1.79.877 1.858 1.565.011.101.016.198.016.29 0 .506-.298.983-.776 1.3.442.289.776.746.776 1.314 0 .09-.005.185-.016.288zM9.043 8.378a.318.318 0 0 1-.253-.302.311.311 0 0 1 .241-.312c.486-.123 1.01-.489 1.01-1.001a2.04 2.04 0 0 0-.012-.228c-.043-.433-.456-.929-1.26-.997h-.304c-.837.076-1.934 1.177-3.181 2.538 1.401 1.634 2.444 2.46 3.181 2.524h.304c.804-.068 1.217-.563 1.26-.997.009-.08.012-.155.012-.226 0-.514-.514-.899-.998-.999zm13.974 3.329l-3.892-3.643 3.892-3.642.477.494-3.369 3.148 3.369 3.146-.477.497zm-8.079-3.558l.005-.132.001-.007c0-3.812-3.146-6.914-7.012-6.914C4.066 1.096.918 4.198.918 8.01s3.148 6.913 7.014 6.913a7.034 7.034 0 0 0 6.117-3.538l.673.664a7.962 7.962 0 0 1-6.79 3.781C3.558 15.83 0 12.322 0 8.01S3.558.19 7.932.19c4.284 0 7.784 3.366 7.925 7.557l7.493 7.014 2.582-2.296v-8.63l-2.59-2.554-4.854 4.786-.667-.623L23.342 0l3.509 3.459v9.409l-3.518 3.128-8.395-7.847z" /
    >
    <
    /svg>
  );
};

export const Gift = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    viewBox = "0 0 120 120"
    style = {
      {
        width: '100%'
      }
    }
    className = {
      className
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M59.937 0c33.103 0 59.938 26.863 59.938 60s-26.835 60-59.938 60C26.835 120 0 93.137 0 60S26.835 0 59.937 0z" /
    >
    <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M81.39 44.533h-6.738a8.662 8.662 0 0 0 .158-1.592c0-2.216-.762-4.13-2.261-5.689-1.448-1.506-3.266-2.269-5.401-2.269-2.139 0-3.976.757-5.531 2.324a9.697 9.697 0 0 0-.759 1.011 9.66 9.66 0 0 0-.842-1.066c-1.447-1.506-3.265-2.269-5.398-2.269-2.159 0-3.99.763-5.458 2.286-1.462 1.569-2.204 3.478-2.204 5.672 0 .554.063 1.081.158 1.592h-7.06c-.116 0-.219.043-.327.068-.108-.025-.21-.068-.326-.068-.817 0-1.478.687-1.478 1.535v9.125c0 .848.661 1.535 1.478 1.535h2.956V76.91c0 5.161 2.76 8.032 7.785 8.084h20.806c4.961-.052 7.721-2.917 7.77-8.084V56.728h2.672c.817 0 1.478-.687 1.478-1.535v-9.125c0-.848-.661-1.535-1.478-1.535zm-18.951-1.697a3.769 3.769 0 0 1 .116-1.145c.22-.846.63-1.607 1.187-2.252.941-.945 2.024-1.386 3.406-1.386 1.342 0 2.423.447 3.309 1.369.952.989 1.397 2.108 1.397 3.519a5 5 0 0 1-.272 1.592H62.66c-.032-.098-.072-.202-.093-.292-.113-.503-.152-.869-.13-1.187.006-.073.006-.145.002-.218zm-11.171-3.414c.887-.921 1.983-1.369 3.35-1.369 1.358 0 2.409.435 3.282 1.343.67.729 1.099 1.48 1.304 2.266.082.341.12.748.12 1.279 0 .495-.041.921-.119 1.274-.026.108-.067.212-.103.318h-8.918a4.99 4.99 0 0 1-.272-1.592c0-1.389.449-2.547 1.356-3.519zM45.314 76.91V56.728h13.52v25.196h-8.678c-3.395-.035-4.842-1.535-4.842-5.014zm25.619 5.014H61.79V56.728h13.972v20.167c-.035 3.537-1.438 4.994-4.829 5.029zm8.978-28.265H40.879v-6.056h39.032v6.056z" /
    >
    <
    /svg>
  );
};

export const Like = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    viewBox = "0 0 120 120"
    style = {
      {
        width: '100%'
      }
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M59.937 0c33.103 0 59.938 26.863 59.938 60s-26.835 60-59.938 60C26.835 120 0 93.137 0 60S26.835 0 59.937 0z"
    className = {
      className
    }
    /> <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M84.901 60.902c.007-.132.015-.152-.017-.28-.019-.182-.019-.991-.019-1.927 0-.079-.007-.158-.021-.236a4.272 4.272 0 0 0-1.23-2.345c-.804-.791-2.026-1.192-3.632-1.192H67.265a8.138 8.138 0 0 0 .717-2.523c.051-.513.084-2.496.084-5.173 0-.067-.005-.134-.015-.2l-1.01-6.686a4.131 4.131 0 0 0-1.188-2.166c-.861-.843-1.883-1.234-2.95-1.187-1.237-.058-2.301.365-3.086 1.189-.833.819-1.241 1.799-1.216 2.891l-1.259 6.721c-1.819 5.338-4.468 9.087-7.882 11.185a2.782 2.782 0 0 0-.248-.283c-.39-.369-1.094-.789-2.216-.759h-8.851c-.942-.028-1.733.226-2.303.767-.573.543-.863 1.301-.863 2.253v20.005c0 1.864 1.195 3.021 3.119 3.021h8.898c1.274 0 2.228-.558 2.717-1.486 1.468.7 3.14 1.16 5.069 1.335h21.479c1.247 0 2.341-.451 3.245-1.337l.231-.225c.038-.037.074-.076.106-.116.628-.771.975-1.705 1.033-2.846 0-.947-.282-1.799-.826-2.549.311-.176.61-.377.885-.628a1.8 1.8 0 0 0 .121-.126l.168-.202c.679-.766 1.052-1.715 1.108-2.946-.034-.768-.226-1.457-.554-2.042a4.693 4.693 0 0 0 .938-.758c.815-.909 1.229-1.934 1.229-3.046 0-.994-.296-1.879-.881-2.642.203-.143.396-.304.58-.484.778-.814 1.201-1.815 1.257-2.977zM47.292 80.956c0 .154-.021.238-.015.257a.909.909 0 0 1-.281.032h-8.898c-.185 0-.287-.025-.3-.018a.85.85 0 0 1-.032-.271V60.951c0-.152.018-.242.013-.271.047-.01.142-.022.319-.017l8.947-.001.063-.001c.077-.001.128.003.154.001.012.047.03.137.03.289v20.005zM81.641 61.98c-.291.286-.659.425-1.222.429l-.536.037a1.377 1.377 0 0 0-1.294 1.363v.151c0 .657.477 1.221 1.136 1.342.365.067.641.214.92.487.359.353.513.718.513 1.216 0 .441-.17.835-.511 1.214-.36.353-.732.503-1.126.508l-.46-.037a1.38 1.38 0 0 0-1.472 1.047 1.36 1.36 0 0 0 .838 1.582c.207.082.366.191.601.442.336.31.497.683.52 1.08-.024.493-.161.863-.449 1.19l-.128.15a1.713 1.713 0 0 1-1.176.445c-.091 0-.17.035-.256.051-.686-.139-1.376.22-1.602.883-.22.642.076 1.331.665 1.638.086.065.361.287.936.852.392.382.551.746.553 1.182-.025.468-.15.848-.383 1.157l-.17.166c-.39.383-.76.539-1.277.539l-21.347.006c-1.884-.175-3.496-.703-4.836-1.532V61.756c4.415-2.349 7.766-6.766 9.939-13.197.021-.06.037-.121.048-.183l1.304-6.958c.018-.102.027-.244.021-.349-.019-.391.093-.661.432-.994.253-.268.559-.379 1.081-.358.403-.018.675.091.981.39.229.224.364.468.413.699l.982 6.52c-.001 3.374-.052 4.611-.068 4.779-.149 1.244-.687 2.327-1.596 3.217-.399.39-.518.978-.302 1.489.215.511.724.844 1.287.844h15.382c.803 0 1.407.141 1.66.389.226.222.362.467.436.784 0 1.232.002 1.751.031 2.056-.041.455-.199.813-.468 1.096z" /
    >
    <
    /svg>
  );
};

export const Checklist = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    viewBox = "0 0 120 120"
    style = {
      {
        width: '100%'
      }
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M59.937 0c33.103 0 59.938 26.863 59.938 60s-26.835 60-59.938 60C26.835 120 0 93.137 0 60S26.835 0 59.937 0z"
    className = {
      className
    }
    /> <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M59.619 71.81l-5.579 6.631a1.189 1.189 0 0 1-1.722.125l-3.097-2.78a1.301 1.301 0 0 1-.124-1.79 1.192 1.192 0 0 1 1.725-.128l2.175 1.952 4.777-5.678a1.194 1.194 0 0 1 1.726-.121c.509.46.562 1.261.119 1.789zM54.04 61.066a1.189 1.189 0 0 1-1.722.125l-3.097-2.78a1.3 1.3 0 0 1-.124-1.789 1.19 1.19 0 0 1 1.725-.129l2.175 1.952 4.777-5.677a1.193 1.193 0 0 1 1.726-.122c.509.46.562 1.262.119 1.789l-5.579 6.631zm5.579 2.159l-5.579 6.631a1.203 1.203 0 0 1-.922.434c-.284 0-.57-.101-.8-.309L49.221 67.2a1.3 1.3 0 0 1-.124-1.789 1.192 1.192 0 0 1 1.725-.129l2.175 1.953 4.777-5.678a1.195 1.195 0 0 1 1.726-.122c.509.461.562 1.262.119 1.79zm16.08 3.825c.677 0 1.224.568 1.224 1.269v15.263c0 .701-.547 1.269-1.224 1.269H44.164c-.677 0-1.224-.568-1.224-1.269V42.7c0-.701.547-1.269 1.224-1.269h7.013c.182-.267.382-.525.616-.768.9-.922 1.972-1.445 3.197-1.561l.006-.023a5.092 5.092 0 0 1 .701-1.794c.2-.301.421-.577.656-.835 1.026-1.049 2.246-1.565 3.658-1.565 1.268 0 2.371.415 3.28 1.234.133.121.236.217.327.313a5.128 5.128 0 0 1 1.415 2.687c1.156.146 2.174.661 3.031 1.537.237.245.439.506.622.775h7.013c.677 0 1.224.568 1.224 1.269v15.398c0 .701-.547 1.269-1.224 1.269-.676 0-1.223-.568-1.223-1.269V43.969h-4.897c.02.196.054.387.054.591 0 1.526-.53 2.833-1.575 3.887a1.2 1.2 0 0 1-.853.359H52.658a1.2 1.2 0 0 1-.853-.359c-1.045-1.054-1.575-2.361-1.575-3.887 0-.204.034-.395.054-.591h-4.897v38.344h29.089V68.319c0-.701.547-1.269 1.223-1.269zM53.203 46.268H66.66c.357-.487.526-1.04.526-1.708 0-.825-.277-1.513-.846-2.103-.582-.595-1.265-.845-2.095-.843-.081 0-.161.001-.236.008a1.175 1.175 0 0 1-.931-.331 1.29 1.29 0 0 1-.395-.934v-.164c0-.789-.252-1.414-.795-1.967-.065-.068-.125-.121-.185-.176-.474-.427-1.021-.627-1.692-.627-.767 0-1.375.255-1.91.803a4.04 4.04 0 0 0-.369.468 2.585 2.585 0 0 0-.344.913l-.243 1.047a1.238 1.238 0 0 1-1.29.968c-.103-.01-.215-.007-.326-.008-.796 0-1.454.278-2.012.849-.563.584-.84 1.272-.84 2.097 0 .668.169 1.221.526 1.708z" /
    >
    <
    /svg>
  );
};

export const Tag = props => {
  const {
    className
  } = props;

  return ( <
    svg xmlns = "http://www.w3.org/2000/svg"
    viewBox = "0 0 120 120"
    style = {
      {
        width: '100%'
      }
    } >
    <
    path fill = "#EFC874"
    fillRule = "evenodd"
    d = "M59.937 0c33.103 0 59.938 26.863 59.938 60s-26.835 60-59.938 60C26.835 120 0 93.137 0 60S26.835 0 59.937 0z"
    className = {
      className
    }
    /> <
    path fill = "#FFF"
    fillRule = "evenodd"
    d = "M83.463 62.086L60.562 84.971 41.116 82.35c-1.898-.29-3.139-1.547-3.429-3.454l-2.746-19.561 22.893-22.914c.974-.977 2.018-1.473 3.106-1.473 1.086 0 2.131.496 3.107 1.474h.001l19.403 19.46c1.922 1.981 1.922 4.237.012 6.204zm-1.973-4.271L62.1 38.368c-.303-.304-.75-.665-1.16-.665-.41 0-.856.362-1.159.665L37.858 60.311l2.552 18.186c.109.711.406 1.021 1.097 1.125l18.074 2.436 21.923-21.906c.848-.875.848-1.447-.014-2.337zM49.756 75.083c-1.322 0-2.461-.468-3.383-1.393a4.691 4.691 0 0 1-1.393-3.387c0-1.325.469-2.465 1.395-3.388.949-.949 2.087-1.43 3.381-1.43 1.296 0 2.434.481 3.384 1.432.894.893 1.375 2.014 1.429 3.33-.055 1.412-.55 2.563-1.429 3.443-.923.925-2.063 1.393-3.384 1.393zm1.44-6.216c-.434-.434-.878-.627-1.44-.627-.561 0-1.004.193-1.436.624l-.002.003c-.406.404-.586.847-.586 1.436 0 .573.192 1.044.588 1.439.404.406.846.586 1.436.586.598 0 1.028-.175 1.438-.586.394-.394.598-.885.625-1.498a2.031 2.031 0 0 0-.623-1.377z" /
    >
    <
    /svg>
  );
};

export const TrashIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "16px"
    height = "20px" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M15.421 3.71h-.248v14.679c-.023 1.019-.633 1.62-1.632 1.62H2.374c-1.022 0-1.632-.606-1.632-1.62V3.71H.573a.574.574 0 0 1 0-1.15h3.153v-.406c0-1.371.785-2.157 2.154-2.157h.522l.007.001.008-.001h3.696c.528 0 .984.121 1.355.361.535.373.799.974.799 1.796v.406h3.154a.574.574 0 0 1 0 1.15zm-4.302-1.556c0-.424-.098-.707-.291-.842-.165-.106-.411-.165-.715-.165H6.417l-.008-.002-.007.002H5.88c-.743 0-1.006.263-1.006 1.007v.406h6.245v-.406zm2.906 1.556H1.889v14.679c0 .359.067.47.485.47h11.167c.38 0 .476-.095.484-.483V3.71zm-3.233 12.755a.575.575 0 0 1-.574-.575V6.712a.574.574 0 1 1 1.148 0v9.178a.575.575 0 0 1-.574.575zm-2.874 0a.575.575 0 0 1-.574-.575V6.712a.574.574 0 1 1 1.148 0v9.178a.575.575 0 0 1-.574.575zm-2.875 0a.575.575 0 0 1-.574-.575V6.712a.574.574 0 1 1 1.148 0v9.178a.575.575 0 0 1-.574.575z" /
    >
    <
    /svg>
  );
};

export const BuffetIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "30"
    height = "30" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M 3.023438 0.324219 C -0.632812 2.09375 -0.957031 9.207031 2.519531 11.34375 C 3.269531 11.804688 3.257812 11.085938 2.675781 19.699219 C 2.167969 27.226562 2.160156 28.371094 2.613281 28.980469 C 3.652344 30.378906 5.980469 30.308594 6.882812 28.855469 C 7.316406 28.152344 7.3125 28.101562 6.722656 19.371094 C 6.15625 11.015625 6.136719 11.800781 6.886719 11.34375 C 12.046875 8.175781 8.382812 -2.277344 3.023438 0.324219 M 12.78125 0.226562 C 12.632812 0.613281 12.679688 10.308594 12.832031 10.96875 C 13.015625 11.761719 13.710938 12.386719 14.40625 12.386719 C 15.039062 12.386719 15.03125 11.488281 14.476562 19.75 C 13.921875 28.066406 13.917969 28.273438 14.394531 28.972656 C 15.433594 30.507812 17.777344 30.320312 18.621094 28.640625 L 18.960938 27.964844 L 18.515625 21.257812 C 18.269531 17.570312 18.027344 14.066406 17.976562 13.46875 L 17.886719 12.386719 L 18.359375 12.386719 C 20.050781 12.386719 20.160156 11.960938 20.113281 5.496094 L 20.074219 0.0742188 L 19.179688 0.0742188 L 19.140625 4.367188 L 19.101562 8.65625 L 16.867188 8.65625 L 16.867188 -0.0195312 L 16.457031 0.0273438 L 16.042969 0.0742188 L 16.003906 4.367188 L 15.964844 8.65625 L 13.734375 8.65625 L 13.695312 4.367188 L 13.65625 0.0742188 L 13.265625 0.0273438 C 13.011719 0 12.839844 0.0703125 12.78125 0.226562 M 28.324219 0.667969 C 27.210938 1.546875 26.335938 2.660156 25.742188 3.957031 C 24.882812 5.824219 24.851562 6.117188 24.851562 12.1875 C 24.851562 18.328125 24.832031 18.214844 25.835938 18.4375 L 26.269531 18.53125 L 26.269531 23.609375 C 26.269531 28.039062 26.300781 28.738281 26.511719 29.097656 C 27.011719 29.945312 28.1875 30.25 29.109375 29.773438 C 30.050781 29.289062 30.003906 30.082031 29.964844 14.371094 L 29.925781 0.0742188 L 29.550781 0.0351562 C 29.296875 0.00390625 28.914062 0.203125 28.324219 0.667969 M 5.425781 1.058594 C 7.785156 1.710938 9.101562 5.710938 7.855469 8.429688 C 6.339844 11.742188 3.269531 11.894531 1.683594 8.730469 C -0.109375 5.15625 2.3125 0.191406 5.425781 1.058594 M 29.105469 9.484375 L 29.105469 17.472656 L 25.894531 17.386719 L 25.851562 12.460938 C 25.804688 6.84375 25.878906 6.125 26.714844 4.402344 C 27.246094 3.300781 28.648438 1.492188 28.96875 1.492188 C 29.050781 1.492188 29.105469 4.71875 29.105469 9.484375 M 19.105469 10.214844 C 19.105469 11.320312 18.742188 11.492188 16.390625 11.492188 C 14.117188 11.492188 13.730469 11.296875 13.730469 10.15625 L 13.730469 9.550781 L 19.105469 9.550781 L 19.105469 10.214844 M 5.222656 12.144531 C 5.222656 12.15625 5.457031 15.679688 5.746094 19.976562 C 6.238281 27.339844 6.253906 27.816406 6.019531 28.210938 C 5.355469 29.335938 3.753906 29.191406 3.277344 27.960938 C 3.203125 27.773438 3.363281 24.507812 3.664062 20.050781 C 3.945312 15.878906 4.175781 12.359375 4.179688 12.230469 C 4.179688 12.054688 4.304688 12.015625 4.703125 12.0625 C 4.988281 12.09375 5.222656 12.132812 5.222656 12.144531 M 16.929688 12.875 C 17.332031 15.441406 17.921875 27.972656 17.652344 28.332031 C 16.964844 29.253906 15.667969 29.191406 15.195312 28.207031 C 14.957031 27.710938 14.96875 27.316406 15.453125 20.222656 C 15.734375 16.121094 15.964844 12.675781 15.964844 12.574219 C 15.976562 12.105469 16.851562 12.375 16.929688 12.875 M 29.101562 23.320312 C 29.101562 28.640625 29.070312 28.847656 28.261719 28.925781 C 27.3125 29.019531 27.3125 29.03125 27.3125 23.496094 L 27.3125 18.507812 L 29.105469 18.507812 L 29.101562 23.320312 M 15.480469 26.140625 C 14.980469 26.417969 15.148438 27.328125 15.8125 27.976562 L 16.402344 28.554688 L 16.910156 28.167969 C 18.460938 26.984375 17.1875 25.183594 15.480469 26.140625 M 16.703125 26.804688 C 17.097656 26.445312 17.253906 26.765625 16.910156 27.234375 C 16.511719 27.777344 15.820312 27.515625 15.820312 26.820312 C 15.820312 26.53125 15.832031 26.53125 16.121094 26.792969 C 16.402344 27.046875 16.433594 27.046875 16.703125 26.804688" /
    >
    <
    /svg>
  );
};

export const AssessoriaIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "22"
    height = "29" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M 7.238281 0.105469 C 7.203125 0.164062 7.03125 0.863281 6.855469 1.652344 C 6.679688 2.441406 6.5 3.199219 6.460938 3.339844 C 6.394531 3.574219 6.675781 3.589844 10.917969 3.589844 C 15.132812 3.589844 15.441406 3.574219 15.4375 3.339844 C 15.433594 3.199219 15.28125 2.410156 15.097656 1.578125 L 14.765625 0.0703125 L 11.035156 0.0351562 C 8.984375 0.0117188 7.277344 0.0429688 7.238281 0.105469 M 0.0664062 2.332031 C 0.0273438 2.433594 0.015625 8.457031 0.0351562 15.722656 L 0.0742188 28.933594 L 21.925781 28.933594 L 21.964844 15.738281 C 21.992188 6.109375 21.957031 2.492188 21.835938 2.347656 C 21.574219 2.035156 17.273438 2.066406 17.394531 2.382812 C 17.445312 2.507812 17.484375 2.730469 17.484375 2.882812 C 17.484375 3.140625 17.605469 3.160156 19.230469 3.160156 L 20.980469 3.160156 L 20.980469 28 L 1.019531 28 L 1.019531 3.160156 L 2.679688 3.160156 C 4.4375 3.160156 4.515625 3.128906 4.515625 2.429688 C 4.515625 2.085938 0.199219 1.992188 0.0664062 2.332031 M 7.175781 7.949219 C 6.796875 8.539062 6.230469 9.429688 5.921875 9.921875 L 5.355469 10.820312 L 4.722656 10.148438 C 3.730469 9.097656 2.9375 9.449219 3.765625 10.574219 C 5.082031 12.363281 5.488281 12.511719 6.171875 11.453125 C 8.046875 8.539062 8.652344 7.441406 8.5 7.207031 C 8.171875 6.691406 7.882812 6.851562 7.175781 7.949219 M 10.644531 9.683594 C 10.515625 9.835938 10.511719 9.964844 10.632812 10.1875 C 10.789062 10.480469 10.875 10.484375 14.613281 10.449219 L 18.429688 10.410156 L 18.480469 10.066406 C 18.507812 9.878906 18.441406 9.671875 18.332031 9.601562 C 17.96875 9.375 10.839844 9.449219 10.644531 9.683594 M 4.460938 15.007812 C 3.871094 15.589844 4.839844 17.660156 5.695312 17.660156 C 6.417969 17.660156 7.4375 15.9375 7.113281 15.265625 C 6.867188 14.761719 4.90625 14.570312 4.460938 15.007812 M 6.019531 15.675781 C 6.253906 15.460938 6.414062 15.398438 6.476562 15.5 C 6.621094 15.726562 6.453125 16.136719 6.070312 16.488281 L 5.738281 16.796875 L 5.25 16.300781 C 4.828125 15.875 4.789062 15.773438 4.957031 15.574219 C 5.136719 15.363281 5.175781 15.371094 5.410156 15.675781 L 5.664062 16.007812 L 6.019531 15.675781 M 10.628906 15.949219 C 10.265625 16.621094 10.507812 16.664062 14.625 16.621094 L 18.429688 16.585938 L 18.480469 16.242188 C 18.558594 15.691406 18.324219 15.65625 14.464844 15.652344 C 10.902344 15.652344 10.785156 15.660156 10.628906 15.949219 M 4.457031 21.089844 C 3.886719 21.714844 4.8125 23.691406 5.675781 23.691406 C 6.757812 23.691406 7.707031 21.175781 6.722656 20.910156 C 6.070312 20.734375 4.6875 20.84375 4.457031 21.089844 M 5.414062 21.777344 C 5.664062 21.996094 5.703125 21.996094 5.964844 21.761719 C 6.554688 21.234375 6.730469 21.746094 6.179688 22.390625 C 5.703125 22.945312 5.636719 22.941406 5.167969 22.335938 C 4.664062 21.683594 4.847656 21.269531 5.414062 21.777344 M 10.582031 22.039062 C 10.335938 22.675781 10.445312 22.695312 14.550781 22.652344 L 18.429688 22.617188 L 18.429688 21.898438 L 14.550781 21.859375 C 11.191406 21.828125 10.65625 21.851562 10.582031 22.039062" /
    >
    <
    /svg>
  );
};

export const DecoracaoIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "19"
    height = "30" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M 7.390625 2.335938 C 7.390625 5.023438 7.535156 5.457031 8.601562 5.925781 L 9.199219 6.183594 L 9.199219 8.582031 L 8.550781 7.953125 C 8.195312 7.605469 7.789062 7.324219 7.648438 7.324219 C 7.148438 7.324219 7.394531 7.859375 8.292969 8.742188 L 9.199219 9.628906 L 9.195312 10.832031 L 9.191406 12.03125 L 8.875 11.507812 C 8.046875 10.15625 6.90625 8.492188 6.296875 7.75 C 5.625 6.933594 5.625 6.929688 5.902344 6.585938 C 6.230469 6.1875 6.28125 4.890625 5.988281 4.398438 C 5.445312 3.476562 3.535156 1.046875 3.355469 1.046875 C 3.242188 1.046875 2.953125 1.476562 2.710938 2 C 2.230469 3.050781 2.105469 3.136719 1.082031 3.140625 C -0.304688 3.144531 -0.289062 3.289062 1.386719 5.550781 C 2.816406 7.480469 3.597656 7.929688 4.742188 7.488281 C 4.957031 7.402344 5.121094 7.476562 5.371094 7.757812 L 5.707031 8.144531 L 5.304688 8.222656 C 4.632812 8.347656 4.808594 8.734375 5.578125 8.816406 C 6.292969 8.898438 6.9375 9.628906 8.078125 11.640625 L 8.449219 12.300781 L 7.703125 11.609375 C 6.28125 10.289062 4.257812 9.164062 2.152344 8.519531 C 0.65625 8.0625 0.453125 8.097656 0.453125 8.808594 C 0.453125 11.980469 2.933594 16.722656 5.988281 19.398438 C 7.210938 20.46875 7.210938 20.53125 6.03125 24.882812 C 5.535156 26.722656 5.128906 28.398438 5.128906 28.609375 L 5.128906 28.992188 L 9.503906 28.992188 C 13.121094 28.992188 13.898438 28.957031 13.964844 28.785156 C 14.007812 28.667969 13.632812 27.050781 13.128906 25.183594 C 12.554688 23.054688 12.214844 21.5 12.214844 21.003906 L 12.214844 20.210938 L 13.4375 19.035156 C 16.304688 16.277344 18.070312 13.011719 18.550781 9.574219 C 18.75 8.140625 18.699219 8.09375 17.304688 8.421875 C 15.746094 8.789062 13.714844 9.796875 12.148438 10.980469 L 10.804688 12 L 11.230469 11.269531 C 12.417969 9.234375 12.808594 8.816406 13.527344 8.816406 C 14.261719 8.816406 14.449219 8.34375 13.757812 8.246094 C 12.910156 8.128906 13.796875 7.546875 14.824219 7.546875 C 16.078125 7.546875 16.34375 7.355469 17.804688 5.40625 C 19.296875 3.410156 19.304688 3.246094 17.875 3.125 C 17.300781 3.074219 16.804688 2.960938 16.773438 2.867188 C 16.601562 2.355469 15.882812 1.125 15.730469 1.082031 C 15.539062 1.023438 13.554688 3.578125 13.085938 4.476562 C 12.742188 5.136719 12.746094 5.773438 13.09375 6.449219 L 13.367188 6.988281 L 12.601562 7.980469 C 11.921875 8.863281 11.828125 8.933594 11.753906 8.632812 C 11.554688 7.800781 11.089844 8.238281 11 9.339844 C 10.9375 10.128906 10.804688 10.570312 10.472656 11.132812 L 10.027344 11.882812 L 9.941406 8.617188 L 10.550781 8 C 11.449219 7.09375 11.214844 6.347656 10.300781 7.199219 L 9.953125 7.523438 L 9.953125 6.863281 C 9.953125 6.257812 10 6.179688 10.507812 5.902344 C 11.597656 5.3125 11.6875 5.054688 11.6875 2.421875 C 11.6875 -0.3125 11.652344 -0.363281 10.355469 0.484375 L 9.574219 0.996094 L 8.746094 0.496094 C 7.363281 -0.332031 7.390625 -0.367188 7.390625 2.335938 M 9.742188 2.144531 C 11.457031 3.660156 11.351562 5.378906 9.539062 5.378906 C 8.363281 5.378906 7.992188 4.679688 7.992188 2.449219 L 7.992188 0.878906 L 8.457031 1.148438 C 8.710938 1.296875 9.289062 1.746094 9.742188 2.144531 M 11.007812 1.679688 L 11.007812 2.308594 L 10.59375 1.894531 C 10.1875 1.488281 10.1875 1.472656 10.472656 1.261719 C 10.921875 0.929688 11.007812 0.996094 11.007812 1.679688 M 4.417969 3.445312 C 5.742188 5.261719 5.828125 5.765625 4.949219 6.5 C 3.28125 7.890625 2.101562 6.09375 2.945312 3.445312 C 3.414062 1.980469 3.347656 1.980469 4.417969 3.445312 M 16.140625 3.40625 C 16.816406 5.558594 16.382812 6.875 14.988281 6.875 C 13.351562 6.875 13.175781 5.527344 14.5625 3.605469 C 15.6875 2.046875 15.710938 2.042969 16.140625 3.40625 M 1.984375 4.339844 C 1.921875 5.007812 1.773438 4.976562 1.3125 4.195312 L 1.039062 3.738281 L 1.542969 3.738281 C 2.039062 3.738281 2.042969 3.746094 1.984375 4.339844 M 17.945312 3.820312 C 17.945312 3.863281 17.773438 4.148438 17.566406 4.453125 C 17.359375 4.753906 17.191406 4.925781 17.191406 4.835938 C 17.191406 4.746094 17.148438 4.460938 17.097656 4.203125 C 17.007812 3.761719 17.027344 3.738281 17.472656 3.738281 C 17.730469 3.738281 17.945312 3.773438 17.945312 3.820312 M 3.5625 9.804688 C 7.242188 11.410156 10.007812 14.625 11.167969 18.644531 C 11.46875 19.6875 11.476562 19.679688 10.699219 19.316406 C 10.222656 19.09375 10.097656 18.929688 9.878906 18.234375 C 9.285156 16.355469 7.398438 13.449219 6.773438 13.449219 C 6.304688 13.449219 6.4375 13.847656 7.261719 14.914062 C 8.6875 16.75 9.726562 19.308594 8.988281 19.167969 C 8.761719 19.128906 8.4375 19.199219 8.222656 19.335938 C 6.488281 20.464844 1.207031 12.933594 1.207031 9.324219 C 1.207031 8.925781 1.859375 9.058594 3.5625 9.804688 M 17.859375 9.527344 C 17.308594 12.726562 15.847656 15.496094 13.402344 18.007812 L 12.09375 19.347656 L 11.925781 18.679688 C 11.636719 17.554688 11 15.960938 10.472656 15.0625 L 9.972656 14.210938 L 10.636719 13.40625 C 12.09375 11.65625 14.308594 10.175781 16.738281 9.328125 C 18.015625 8.886719 17.972656 8.878906 17.859375 9.527344 M 4.171875 11.757812 C 3.980469 11.949219 4.074219 12.097656 4.632812 12.472656 C 5.3125 12.929688 5.730469 12.964844 5.730469 12.566406 C 5.730469 12.097656 4.480469 11.449219 4.171875 11.757812 M 9.554688 20.476562 C 9.683594 20.476562 9.867188 20.335938 9.957031 20.167969 C 10.089844 19.917969 10.167969 19.894531 10.339844 20.035156 C 10.667969 20.304688 10.601562 20.578125 10.058594 21.164062 L 9.5625 21.703125 L 9 21.085938 C 8.507812 20.546875 8.460938 20.425781 8.613281 20.144531 L 8.789062 19.820312 L 9.054688 20.148438 C 9.203125 20.328125 9.425781 20.476562 9.554688 20.476562 M 7.941406 21.109375 C 8.136719 21.492188 8.128906 21.519531 7.84375 21.519531 C 7.585938 21.519531 7.542969 21.429688 7.550781 20.886719 C 7.558594 20.535156 7.601562 20.351562 7.648438 20.476562 C 7.695312 20.597656 7.824219 20.882812 7.941406 21.109375 M 11.460938 20.921875 C 11.460938 21.371094 11.398438 21.519531 11.21875 21.519531 C 11.046875 21.519531 11.007812 21.445312 11.085938 21.261719 C 11.148438 21.117188 11.230469 20.847656 11.269531 20.660156 C 11.382812 20.152344 11.460938 20.257812 11.460938 20.921875 M 9.046875 22.34375 C 9.152344 22.464844 9.351562 22.566406 9.496094 22.566406 C 9.714844 22.566406 9.792969 22.847656 9.988281 24.304688 C 10.214844 25.976562 10.429688 26.488281 10.765625 26.152344 C 10.890625 26.03125 10.6875 23.734375 10.449219 22.53125 C 10.371094 22.136719 10.394531 22.117188 10.964844 22.117188 L 11.5625 22.117188 L 12.339844 25.015625 C 13.296875 28.574219 13.320312 28.246094 12.140625 28.246094 C 11.28125 28.246094 11.160156 28.210938 11.160156 27.964844 C 11.160156 27.550781 10.792969 27.292969 10.574219 27.554688 C 10.476562 27.667969 10.441406 27.871094 10.492188 28.003906 C 10.578125 28.222656 10.34375 28.246094 8.222656 28.246094 C 6.042969 28.246094 5.867188 28.226562 5.9375 27.984375 C 5.980469 27.839844 6.328125 26.546875 6.710938 25.109375 C 7.09375 23.667969 7.433594 22.410156 7.46875 22.304688 C 7.558594 22.035156 8.816406 22.066406 9.046875 22.34375" /
    >
    <
    /svg>
  );
};

export const LocalIcon = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "30"
    height = "26" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M 3.058594 0.335938 C 3.011719 0.519531 2.996094 2.523438 3.019531 4.785156 L 3.058594 8.898438 L 3.804688 8.898438 L 3.84375 4.898438 L 3.886719 0.898438 L 26.113281 0.898438 L 26.15625 4.898438 L 26.195312 8.898438 L 26.941406 8.898438 L 26.941406 0.0742188 L 15.039062 0.0351562 L 3.140625 0 L 3.058594 0.335938 M 6.15625 3.164062 C 5.902344 3.417969 5.898438 6.597656 6.148438 6.847656 C 6.351562 7.050781 8.46875 7.09375 8.773438 6.902344 C 8.917969 6.8125 8.953125 6.308594 8.921875 4.921875 L 8.878906 3.066406 L 7.609375 3.023438 C 6.75 2.992188 6.28125 3.039062 6.15625 3.164062 M 11.230469 3.089844 C 10.976562 3.195312 10.96875 6.59375 11.222656 6.847656 C 11.464844 7.089844 13.613281 7.089844 13.851562 6.847656 C 14.097656 6.601562 14.097656 3.417969 13.851562 3.171875 C 13.675781 2.992188 11.625 2.929688 11.230469 3.089844 M 16.222656 3.085938 C 16.167969 3.144531 16.121094 4.011719 16.121094 5.019531 C 16.121094 7.125 16.050781 7.03125 17.585938 7.027344 C 19.007812 7.023438 18.972656 7.078125 18.921875 4.921875 L 18.878906 3.066406 L 17.605469 3.023438 C 16.902344 3 16.28125 3.027344 16.222656 3.085938 M 21.222656 3.171875 C 21.105469 3.289062 21.042969 3.917969 21.042969 5.007812 C 21.042969 7.019531 21.050781 7.027344 22.539062 7.027344 C 24.023438 7.027344 24.03125 7.019531 24.03125 5.007812 C 24.03125 3.917969 23.96875 3.289062 23.851562 3.171875 C 23.613281 2.929688 21.464844 2.929688 21.222656 3.171875 M 8.058594 4.933594 L 8.058594 5.980469 L 7.015625 5.980469 L 7.015625 3.886719 L 8.058594 3.886719 L 8.058594 4.933594 M 12.984375 4.933594 L 12.984375 5.980469 L 11.941406 5.980469 L 11.941406 3.886719 L 12.984375 3.886719 L 12.984375 4.933594 M 18.058594 4.933594 L 18.058594 5.980469 L 17.015625 5.980469 L 17.015625 3.886719 L 18.058594 3.886719 L 18.058594 4.933594 M 23.132812 4.933594 L 23.132812 5.980469 L 21.941406 5.980469 L 21.941406 3.886719 L 23.132812 3.886719 L 23.132812 4.933594 M 2.1875 10.117188 C 1.886719 10.421875 2.101562 10.917969 2.539062 10.917969 L 2.984375 10.917969 L 2.984375 23.179688 L 2.527344 23.179688 C 2.117188 23.179688 2.074219 23.21875 2.117188 23.589844 L 2.164062 24 L 7.835938 24 L 7.882812 23.589844 C 7.925781 23.21875 7.882812 23.179688 7.472656 23.179688 L 7.015625 23.179688 L 7.015625 10.917969 L 23.132812 10.917969 L 23.132812 23.160156 L 22.648438 23.207031 C 22.242188 23.246094 22.164062 23.316406 22.164062 23.628906 L 22.164062 24 L 24.941406 24.042969 C 27.269531 24.074219 27.75 24.046875 27.90625 23.855469 C 28.195312 23.511719 27.980469 23.179688 27.46875 23.179688 L 27.015625 23.179688 L 27.015625 10.917969 L 27.46875 10.917969 C 27.976562 10.917969 28.195312 10.585938 27.910156 10.242188 C 27.714844 10.007812 2.421875 9.886719 2.1875 10.117188 M 5.96875 17.046875 L 5.96875 23.179688 L 3.878906 23.179688 L 3.878906 10.917969 L 5.96875 10.917969 L 5.96875 17.046875 M 26.121094 17.046875 L 26.121094 23.179688 L 24.03125 23.179688 L 24.03125 10.917969 L 26.121094 10.917969 L 26.121094 17.046875 M 13.746094 13.171875 C 12.5625 13.324219 11.226562 13.953125 11.113281 14.40625 C 11.070312 14.582031 11.054688 16.34375 11.078125 18.320312 L 11.121094 21.90625 L 11.53125 21.957031 L 11.941406 22.003906 L 11.941406 14.789062 L 12.597656 14.496094 C 12.960938 14.335938 13.566406 14.164062 13.941406 14.109375 L 14.625 14.015625 L 14.625 15.980469 C 14.625 17.773438 14.601562 17.945312 14.359375 17.945312 C 13.59375 17.945312 13.480469 19.140625 14.179688 19.8125 C 14.578125 20.195312 14.625 20.339844 14.625 21.125 C 14.625 22.441406 15.402344 22.410156 15.523438 21.085938 C 15.574219 20.511719 15.726562 20.070312 16.03125 19.617188 C 16.527344 18.886719 16.464844 18.289062 15.855469 18.023438 C 15.535156 17.878906 15.523438 17.796875 15.523438 15.945312 L 15.523438 14.015625 L 16.1875 14.109375 C 16.554688 14.15625 17.109375 14.320312 17.421875 14.464844 L 17.984375 14.730469 L 18.058594 18.320312 L 18.132812 21.90625 L 18.542969 21.957031 L 18.957031 22.003906 L 18.957031 14.203125 L 18.46875 13.902344 C 17.417969 13.253906 15.449219 12.945312 13.746094 13.171875 M 14.777344 18.769531 C 14.949219 18.972656 15.003906 18.972656 15.320312 18.765625 C 15.800781 18.453125 15.820312 18.890625 15.347656 19.394531 L 15.019531 19.742188 L 14.675781 19.414062 C 14.335938 19.097656 14.199219 18.542969 14.460938 18.542969 C 14.53125 18.542969 14.675781 18.644531 14.777344 18.769531 M 9.132812 23.589844 L 9.179688 24 L 14.941406 24.039062 C 21.035156 24.082031 21.242188 24.058594 20.992188 23.40625 C 20.917969 23.207031 20.132812 23.179688 14.996094 23.179688 L 9.085938 23.179688 L 9.132812 23.589844 M 0.0546875 25.347656 C -0.214844 26.054688 -0.890625 26.023438 15.03125 25.984375 L 29.925781 25.945312 L 29.925781 25.199219 L 15.03125 25.160156 C 1.886719 25.125 0.128906 25.148438 0.0546875 25.347656" /
    >

    <
    /svg>
  );
};

export const Question = props => {
  const {
    className
  } = props;

  return ( <
    svg className = {
      className
    }
    xmlns = "http://www.w3.org/2000/svg"
    width = "30"
    height = "35" >
    <
    path fill = "#040707"
    fillRule = "evenodd"
    d = "M15.255,0c5.424,0,10.764,2.498,10.764,8.473c0,5.51-6.314,7.629-7.67,9.62c-1.018,1.481-0.678,3.562-3.475,3.562 c-1.822,0-2.712-1.482-2.712-2.838c0-5.046,7.414-6.188 7.414-10.343c0-2.287-1.522-3.643-4.066-3.643 c-5.424,0-3.306,5.592-7.414,5.592c-1.483,0-2.756-0.89-2.756-2.584C5.339,3.683,10.084,0,15.255,0z M15.044,24.406 c1.904,0,3.475,1.566,3.475,3.476c0,1.91-1.568,3.476-3.475,3.476c-1.907,0-3.476-1.564-3.476-3.476 C11.568,25.973,13.137,24.406,15.044,24.406z" /
    >

    <
    /svg>
  );
};